import {Image, Tabs} from 'antd';
import type {TabsProps}
from 'antd';

import yifangUrl from '../assets/images/1-about/yifang_ap_20250528.jpeg';
// import yifangUrl from'../assets/images/1-about/yifang-20240105.jpg';
// import yifangUrl from'../assets/images/1-about/yifang-summer-2.jpg';
// import yifangUrl from'../assets/images/1-about/yifang.jpeg';
// import yifangUrl from'../assets/images/1-about/yifang-fall.JPG';
// import yifangUrl from'../assets/images/1-about/yifang-winter.jpg';

// research theme
import HumanGenAIUrl from '../assets/images/2-research/research-topic/HAI.png';
import HAI4DecisionMakingUrl from '../assets/images/2-research/research-topic/HAI4DecisionMaking.png';
import HAI4ScienceUrl from '../assets/images/2-research/research-topic/HAI4Science.png';

// media logo
import KelloggInsightLogoUrl from '../assets/images/1-about/kellogg-insight.jpeg';
import ScienceLogoTransparentUrl from '../assets/images/1-about/science-transparent.png';
import ScienceLogoUrl from '../assets/images/1-about/science.jpeg';
import NatureLogoRawUrl from '../assets/images/1-about/nature.jpg';
import NatureLogoUrl from '../assets/images/1-about/nature-space.jpg';
import MicrosoftResearchLogoUrl from '../assets/images/1-about/ms.jpg';
import MSLogoUrl from '../assets/images/1-about/ms2.jpg';
import HKUSTLibraryLogoUrl from '../assets/images/1-about/hkust_library.png';

// lab members
import hongxinImg from '../assets/images/10-lab-members/hongxin.webp';
import catChestnutImg from '../assets/images/10-lab-members/cat-chestnut.jpg';
import catEggTartImg from '../assets/images/10-lab-members/cat-egg-tart.jpg';
// import qinshiImg from '../assets/images/10-lab-members/qinshi.png'; // hidden with Qinshi Zhang's card below
import chengranImg from '../assets/images/10-lab-members/chengran.png';
import xinyiImg from '../assets/images/10-lab-members/xinyi.jpeg';
import shuoImg from '../assets/images/10-lab-members/shuo.jpg';
import yifangImg from '../assets/images/10-lab-members/yifang.jpg';
import ziqingImg from '../assets/images/10-lab-members/ziqing.jpg';
import shengruiImg from '../assets/images/10-lab-members/shengrui.png';
import haotianImg from '../assets/images/10-lab-members/haotian.jpg';
import weiZhangImg from '../assets/images/10-lab-members/zhangwei.png';
import junxiuImg from '../assets/images/10-lab-members/junxiu.png';
import leixianImg from '../assets/images/10-lab-members/leixian.jpg';
import xiaoyanImg from '../assets/images/10-lab-members/xiaoyan.jpg';
import zhihanImg from '../assets/images/10-lab-members/zhihan.jpg';
import jiachenImg from '../assets/images/10-lab-members/jiachen.jpg';
import yusongImg from '../assets/images/10-lab-members/Yusong_Liang.jpeg';
import tonyImg from '../assets/images/10-lab-members/tony_guo.png';
import haozhongImg from '../assets/images/10-lab-members/haozhong.jpg';

import LLMNativeFigureUrl from '../assets/paper-material/7-llm-native-figure/llm-native-figure-teaser.jpg';
import EMINDSUrl from '../assets/images/2-research/tvch2025-eminds.png';
import IAIUrl from '../assets/images/2-research/IAI.png';
import FtFUrl from '../assets/images/2-research/ftf2025.png';
import ISEA2025_Three_in_OneUrl from '../assets/images/2-research/ISEA2025_Three_in_One.jpg';
import ISEA2025_PentobarbitalUrl from '../assets/images/2-research/ISEA2025_Pentobarbital.jpg';
import PromptingGenerativeAIUrl from '../assets/images/2-research/CHI_LBW_2025__Interaction_Augmented_Instructions.jpg';
import SciSciGPTUrl from '../assets/images/2-research/sciscigpt-system.jpg';
import DietGlanceUrl from '../assets/images/2-research/DietGlance.jpg';
import ArtAnnoUrl from '../assets/images/2-research/ArtAnno.png';
import InclusiVizUrl from '../assets/images/2-research/inclusionviz.jpg';
import lossGenerationUrl from '../assets/images/2-research/loss-generation.jpg';
import CatVisUrl from '../assets/images/2-research/isea2024.jpg';
import NeighVizUrl from '../assets/images/2-research/vds2023-neighviz-img.jpeg';
import LonelyIslandUrl from '../assets/images/2-research/visap2023-lonelyisland.jpg';
import LonelyIslandStoryUrl from '../assets/images/3-data-art/visap2023-lonelyisland/Chinavisap2024-0.JPG';
import InnovationInsightsUrl from '../assets/images/2-research/vis2023-innovationinsights-img-3.JPG';
// import InnovationInsightsUrl from '../assets/images/2-research/vis2023-innovationinsights-img-2.jpg';
// import InnovationInsightsUrl from '../assets/images/2-research/vis2023-innovationinsights-img.jpeg';
import ComparativeStudyUrl from '../assets/images/2-research/tvcg2024-comparative.jpg';
import HealthPrismUrl from '../assets/images/2-research/vis2023-healthprism-img.jpg';
import TCKUrl from '../assets/images/2-research/jcst2023-survey-tcp.jpeg';
import ACSeekerUrl from '../assets/images/2-research/vis2021-acseeker-teaser.jpeg';
import CareerLensUrl from '../assets/images/2-research/tvcg-2020-careerlens-img.jpeg';
import visap2021Url from '../assets/images/2-research/visap2021-shijing-img.jpeg';
import mTSeerUrl from '../assets/images/2-research/chi2021-mtseer-img.jpeg';
import CloudDetUrl from '../assets/images/2-research/vis2019-cloudet-img.jpeg';
import pulseUrl from '../assets/images/2-research/2018-pulse-img.jpeg';
import MARVisTUrl from '../assets/images/2-research/tvcg2018-marvist-img.jpeg';
import urbanARUrl from '../assets/images/2-research/vi2017-urbanar-img.jpeg';

import ArtAnnoVideoUrl from '../assets/paper-material/8-uist-2026/ArtAnno-demo-video.mp4';
import ArtAnnoVideoPreviewUrl from '../assets/paper-material/8-uist-2026/ArtAnno-video-preview.mp4';
import LLMNativeFigureVideoUrl from '../assets/paper-material/7-llm-native-figure/nexus-v2-20260324-compressed.mp4';
import LLMNativeFigureConceptFilmUrl from '../assets/paper-material/7-llm-native-figure/concept-film.mp4';
import LLMNativeFigurePosterUrl from '../assets/paper-material/7-llm-native-figure/NetSci2026-poster.pdf';
import DietGlancePDFUrl from '../assets/paper-material/HEALTH_Dietary_Monitoring_with_Eyewear.pdf';
import DAVAPDFUrl from '../assets/paper-material/tvcg2026/paper.pdf';
import DAVAVideoUrl from '../assets/paper-material/tvcg2026/demo-video.mp4';
import DAVASIUrl from '../assets/paper-material/tvcg2026/si.pdf';
import DAVATeaserUrl from '../assets/paper-material/tvcg2026/teaser.png';

import MAADGPDFUrl from '../assets/paper-material/VISxGenAI_MAADG.pdf';
import GenIAIPDFUrl from '../assets/paper-material/situated_dynamic_geniai_runtime_chi26_workshop.pdf';
import ArtAnnoPDFUrl from '../assets/paper-material/8-uist-2026/ArtAnno-paper.pdf';
import ArtAnnoPDFSIUrl from '../assets/paper-material/8-uist-2026/ArtAnno-si.pdf';
import SurveyHAIPDFUrl from '../assets/paper-material/2026-ai4science-survey/2026-ai4science-survey.pdf';
import SurveyHAITeaserUrl from '../assets/paper-material/2026-ai4science-survey/teaser.png';
import EMINDSPDFUrl from '../assets/paper-material/tvcg2025-eminds/EMINDS.pdf';
import FtFNewsPDFUrl from '../assets/paper-material/6-ftf/Nature-news-in-focus.pdf';
import SciSciGPTVideo from '../assets/paper-material/5-sciscigpt/Demo.mp4';
import ISEA2025_Three_in_OnePaperUrl from '../assets/paper-material/ISEA2025_Three_in_One.pdf';
import ISEA2025_PentobarbitalPaperUrl from '../assets/paper-material/ISEA2025_Pentobarbital.pdf';
import PromptingGenerativeAIPaperUrl from '../assets/paper-material/CHI_LBW_2025__Interaction_Augmented_Instructions.pdf';
import DietGlancePaperUrl from '../assets/paper-material/2025-DietGlance.pdf';
import InclusionVizPaperUrl from '../assets/paper-material/pvis2025-InclusionViz/PVIS2024_InclusiViz.pdf';
import CatVisPaperUrl from '../assets/paper-material/isea2024/ISEA2024_Taurine_0405_Final.pdf';
import NeighVizPaperUrl from '../assets/paper-material/vds2023-neighviz/vds2023-neighviz-paper.pdf';
import LonelyIslandPaperUrl from '../assets/paper-material/visap2023-lonelyisland/vis23k-sub1032-i6.pdf';
import InnovationInsightsPaperUrl from '../assets/paper-material/4-innovationinsights/vis2023_innovationsinsights_paper_20230808.pdf';
import ComparativeStudyPaperUrl from '../assets/paper-material/tvcg2024-comparative.pdf';
import HealthPrismPaperUrl from '../assets/paper-material/vis2023-healthprism/vis2023-healthprism-paper.pdf';
import TCKPaperUrl from '../assets/paper-material/jcst2023-survey-tcp.pdf';
import ACSeekerPaperUrl from '../assets/paper-material/1-acseeker/vis2021-acseeker-paper.pdf';
import CareerLensPaperUrl from '../assets/paper-material/2-careerlens/tvcg-2020-careerlens-paper.pdf';
import visap2021PaperUrl from '../assets/paper-material/3-the-book-of-songs/visap2021-shijing-paper.pdf';
import mTSeerPaperUrl from '../assets/paper-material/chi2021-mtseer-paper.pdf';
import CloudDetPaperUrl from '../assets/paper-material/vis2019-cloudet-paper.pdf';
import pulsePaperUrl from '../assets/paper-material/2018-pulse-paper.pdf';
import MARVisTPaperUrl from '../assets/paper-material/tvcg2018-marvist-paper.pdf';
import urbanARPaperUrl from '../assets/paper-material/vi2017-urbanar-paper.pdf';

import MAADGTeaserUrl from '../assets/images/2-research/vis-workshop-2026.png';
import GenIAITeaserUrl from '../assets/images/2-research/geniai.png';
import AIDancePDFUrl from '../assets/images/3-data-art/NeurIPS-ai-dance-2026/paper.pdf';
import AIDanceVideoUrl from '../assets/images/3-data-art/NeurIPS-ai-dance-2026/video.mp4';
import AIDanceTeaserUrl from '../assets/images/3-data-art/NeurIPS-ai-dance-2026/teaser.png';
import AIDanceNeurIPSLogoUrl from '../assets/images/3-data-art/NeurIPS-ai-dance-2026/NeurIPS_logo.png';
import ChinaInMapsVideoUrl from '../assets/images/3-data-art/chinainmaps/China_in_Maps_video.mp4'
import ChinaInMapsImgUrl from '../assets/images/3-data-art/chinainmaps/China_in_Maps_teaser.jpg'
import lossGenerationVideoUrl from '../assets/paper-material/siggraphart2024-lossgeneration/artg_205s1-yaml3_video.mp4';
import LonelyIslandVideoUrl from '../assets/paper-material/visap2023-lonelyisland/video.mp4';
import InnovationInsightsBackgroundBackgroundVideoUrl from '../assets/paper-material/4-innovationinsights/vis2023_innovationsinsights_video_background.mp4';
import InnovationInsightsBackgroundCaseVideoUrl from '../assets/paper-material/4-innovationinsights/vis2023_innovationsinsights_video_case.mp4';
import HealthPrismVideoUrl from '../assets/paper-material/vis2023-healthprism/vis2023-healthprism-demo-video.mp4';
import ACSeekerVideoUrl from '../assets/paper-material/1-acseeker/vis2021-acseeker-demo-video.mp4';
import CareerLensVideoUrl from '../assets/paper-material/2-careerlens/tvcg-2020-careerlens-demo-video.mp4';
import visap2021VideoUrl from '../assets/paper-material/3-the-book-of-songs/visap.mp4';

import generationLossSlidesUrl from '../assets/paper-material/siggraph2024-loss-of-sonnet-18.pdf';
import InnovationInsightsSlidesUrl from '../assets/paper-material/4-innovationinsights/vis2023-presentation.pdf';
import ACSeekerSlidesUrl from '../assets/paper-material/1-acseeker/vis2021-acseeker-slides.pdf';
import CareerLensSlidesUrl from '../assets/paper-material/2-careerlens/vis2021-careerlens-slides.pdf';
import visap2021SlidesUrl from '../assets/paper-material/3-the-book-of-songs/visap2021-presentation.pdf';

import SciSciGPTPosterUrl from '../assets/paper-material/5-sciscigpt/sciscigpt-poster-v1.1.pdf';
import InclusionVizPosterUrl from '../assets/paper-material/pvis2025-InclusionViz/ChinaVis2024_PosterPaper_InclusiViz.pdf';
import NeighVizSuppUrl from '../assets/paper-material/vds2023-neighviz/vds2023-neighviz-supp.pdf';
import InnovationInsightsSuppUrl from '../assets/paper-material/4-innovationinsights/vis2023_innovationsinsights_supp_dataset_20230808.pdf';
import InnovationInsightsPosterUrl from '../assets/paper-material/4-innovationinsights/icssi2023_innnovationinsights_poster.pdf';
import ACSeekerSuppUrl from '../assets/paper-material/1-acseeker/vis2021-acseeker-supp.pdf';
import CareerLensSuppUrl from '../assets/paper-material/2-careerlens/tvcg-2020-careerlens-supp.pdf';
import visap2021SuppUrl from '../assets/paper-material/3-the-book-of-songs/supp.pdf';

import shijingUrl from '../assets/images/3-data-art/visap2021-shijing-img.jpeg';
import dunhuangUrl from '../assets/images/3-data-art/visap2022-dunhuang.jpeg';
import vis22ReflectionUrl from '../assets/images/3-data-art/vis2022-reflection.jpeg';

import cvUrl from '../assets/images/1-about/ap__cv__2026Fall_AP_FSU_yifang_wang.pdf'
import youtubeIconUrlsm from '../assets/images/4-contacts/202407/youtube.png';
import photoIconUrlsm from '../assets/images/4-contacts/202407/500px.png';
import scholarIconUrlsm from '../assets/images/4-contacts/202407/google-scholar.png';
import cvIconUrlsm from '../assets/images/4-contacts/202407/cv.png';
import twitterIconUrlsm from '../assets/images/4-contacts/202407/twitter.png';
import emailIconUrlsm from '../assets/images/4-contacts/202407/email.png';
import linkedinIconUrlsm from '../assets/images/4-contacts/202407/linkedin.png';
import scholarIconUrl from '../assets/images/4-contacts/fsu/google-scholar.png';
import githubIconUrl from '../assets/images/4-contacts/fsu/github.png';
import twitterIconUrl from '../assets/images/4-contacts/fsu/twitter.png';
import emailIconUrl from '../assets/images/4-contacts/fsu/email.png';
import blueskyIconUrl from '../assets/images/4-contacts/fsu/bluesky.png';
import linkedinIconUrl from '../assets/images/4-contacts/fsu/linkedin.png';
import photoIconUrl from '../assets/images/4-contacts/fsu/500px.png';

import delphiUrl from '../assets/images/6-rd/delphi.jpeg';
import urbanUrl from '../assets/images/6-rd/smart_campus.jpeg';
import pulse2Url from '../assets/images/6-rd/pulse.jpeg';

import fsuUrl from '../assets/images/7-institution-logo/fsu.svg';
import nuUrl from '../assets/images/7-institution-logo/nu.png';
import hkustUrl from '../assets/images/7-institution-logo/hkust.svg';
import zhejianglabUrl from '../assets/images/7-institution-logo/zhejiang_lab.png';
import zjuUrl from '../assets/images/7-institution-logo/zju.png';

// news
import NISciSciGPTImageUrl from '../assets/images/8-news/NI-SciSciGPT.jpg';
import NIIIImageUrl from '../assets/images/8-news/NI-ii.png';
import NIFtFImageUrl from '../assets/images/8-news/NI-FtF.jpg';
import NIInstituteNews from '../assets/images/8-news/NI-institute.png';
import NatureSciSciGPTCoverUrl from '../assets/images/8-news/sciscigpt-cover.png';
import LLMNativeFigureTeaserUrl from '../assets/images/8-news/llm-native-figure-teaser.png';
import NatureCommentSciSciGPT from '../assets/images/8-news/nature-comment-sciscigpt.jpg';
import ChemistryWorldLogoUrl from '../assets/images/8-news/chemistry_world_logo.jpeg';
import CENLogoUrl from '../assets/images/8-news/CEN-teaser.jpg';
import FtFNewsChemistryWorldLogo from '../assets/images/8-news/chemistry-world-logo.png';
import nberLogo from '../assets/images/8-news/nber.png';
import ncsLogo from '../assets/images/8-news/ncs-logo.png';
import NatureNewsFtFUrl from '../assets/images/8-news/nature-news-20251001.jpg';
// import NatureNewsFtFUrl from '../assets/images/8-news/ftf-nature-news.jpeg';
import computationalArtExhibitionUrl from '../assets/images/8-news/computational-art-exhibition.png';
import ISEA2024Logo from '../assets/images/8-news/ISEA2024.jpg';
import InfoPlus23 from '../assets/images/8-news/info+2023.jpg';
import VIS23InnovationInsightsB from '../assets/images/8-news/InnovationInsights-2.jpg';
import VIS23InnovationInsightsA from '../assets/images/8-news/InnovationInsights-1.jpg';
import VISAP23B from '../assets/images/8-news/VISAP23-19.jpeg';
import VISAP23A from '../assets/images/8-news/VISAP23-4.jpeg';
import chinainmaps from '../assets/images/8-news/chinainmaps-1.jpeg';
import IIBLogo from '../assets/images/8-news/IIB-logo.png';
// import vis2023Logo from '../assets/images/8-news/vis2023-logo.svg';
import sparksImg from '../assets/images/8-news/sparks.jpg';
import cssiLogo from '../assets/images/8-news/cssi-logo.jpg';

// data art story
import CatVisVideoUrl from '../assets/images/3-data-art/isea2024/cat-video.mp4';
import LonelyIslandStoryImgUrl1 from '../assets/images/3-data-art/visap2023-lonelyisland/story/lonely-1.jpg';
import LonelyIslandStoryImgUrl2 from '../assets/images/3-data-art/visap2023-lonelyisland/story/lonely-2.jpg';
import TabPane from 'antd/es/tabs/TabPane';
import {Link} from 'react-router-dom';
import FollowTooltip from '../components/FollowTooltip';
import HomePage from '../components/HomePage';

function importAll(r : any) {
    return r.keys().map(r);
}
const ChinaInMapsImgUrlList: string[] = importAll(require.context('../assets/images/3-data-art/chinainmaps/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))
const LonelyIslandStoryImgUrlList: string[] = importAll(require.context('../assets/images/3-data-art/visap2023-lonelyisland/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))
const CatVisImgUrlList: string[] = importAll(require.context('../assets/images/3-data-art/isea2024/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))
const DunhuangImgUrlList: string[] = importAll(require.context('../assets/images/3-data-art/chinavisap2022/', false, /\.(jpg|png|jpe?g|svg|JPG|PNG)$/))
const LossGenerationImgUrlList: string[] = importAll(require.context('../assets/images/3-data-art/siggraphart2024/', false, /\.(png|jpe?g|svg|JPG|png|PNG|mp4|MP4)$/))
const Visap2021ImgUrlList: string[] = importAll(require.context('../assets/images/3-data-art/visap2021/', false, /\.(png|jpe?g|svg|JPG|png|PNG|webp|mp4|MP4)$/))

// data art award logo
const LossGenerationAwardLogoList: string[] = importAll(require.context('../assets/images/3-data-art/prize-logo/LossGeneration/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))
const CatVisAwardLogoList: string[] = importAll(require.context('../assets/images/3-data-art/prize-logo/CatVis/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))
const Visap2021AwardLogoList: string[] = importAll(require.context('../assets/images/3-data-art/prize-logo/Visap2021/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))
const LonelyIslandAwardLogoList: string[] = importAll(require.context('../assets/images/3-data-art/prize-logo/LonelyIsland/', false, /\.(png|jpe?g|svg|JPG|png|PNG)$/))

export enum dataArtAwardCategory {
    VISAP2021 = 'VISAP 2022',
    VISAP2023 = 'VISAP 2023',

    ElectricDreams2022 = 'Electric Dreams 2022',

    IIB2022 = 'Information is Beautiful 2022',
    IIB2023 = 'Information is Beautiful 2023',

    ISEA2024 = 'ISEA 2024',
    SIGGRAPHART = 'SIGGRAPH ART Gallery 2024',

    CHINAVISAP2024 = 'CHINAVISAP 2024',

    INFOPLUS = 'Information+ Conference 2023',

    LumenPrize2024 = 'The Lumen Prize 2024', // The Lumen Prize

    NeurIPS2026 = 'NeurIPS2026 (Creative AI Track)',
}

export enum paperCategory {
    FEATURED = 'Featured',
    ALL = 'All',
    LLM = 'LLM & AI Agent',
    AI4Sci="AI for Science",
    VA = 'Visual Analytics',
    CSS = 'Computational Social Science',
    HEALTH = 'Healthcare',
    DR = 'Data-driven Art',
    DH = 'Digital Humanities',
    IS = 'Immersive Visual Analytics'
}

export enum newsCategory {
    IN2026 = '2026',
    IN2025 = '2025',
    IN2024 = '2024',
    IN2023 = '2023',
    BEFORE2023 = 'Before 2023',
    ALL = 'All',
    TALK = 'Talk',
    MEDIA = 'Media',
    AWARDS = 'Awards',
    VISITS = 'Visits',
    CONFERENCE = 'Conference',
    PUBLICATION = 'Publication'
}

export enum experienceCategory {
    EXPERIENCE = 'Experience',
    SERVICE = 'Research Services',
    // RD = 'R&D',
    TEACHING = 'Teaching'
}

const SciSciIntro: string = '💡 The science of science (SciSci) is based on a transdisciplinary approach that uses large data sets to study the mechanisms underlying the doing of science—from the choice of a research problem to career trajectories and progress within a field. (By Fortunato, Santo, et al. "Science of science." Science 359.6379 (2018): eaao0185)'
const socialMobilityIntro: string = "💡 Social mobility is the movement of individuals, families, households or other categories of people within or between social strata in a society. It is a change in social status relative to one's current social location within a given society. This movement occurs between layers or tiers in an open system of social stratification. (By Wikipedia)"
const dataArtIntro: string = "💡 Information art, which is also known as informatism or data art, is an emerging art form that is inspired by and principally incorporates data, computer science, information technology, artificial intelligence, and related data-driven fields. (By Wikipedia)"


export const textContent = {
    aboutPage: {
        title: 'Hello!',
        introduction: <div>
            <p>I am Yifang Wang, a tenure-track Assistant Professor at the Department of Computer Science at Florida State University.
                My research aims to advance science by changing how humans and AI think together.
                I develop next-generation human–AI interaction paradigms and build practical systems for scientific discovery and decision-making, in which human expertise and judgment meet the efficiency and scale of AI — from the&nbsp;
                <FollowTooltip title={SciSciIntro}>science of science and innovation</FollowTooltip> to science policy-making.
            </p>
            <p>
                As an interdisciplinary researcher, my research has made contributions to multiple disciplines, and I have published in top-tier venues such as Nature Computational Science, IEEE VIS, IEEE TVCG, ACM CHI, ACM UIST, SIGGRAPH Art, and ISEA, and received Best Paper Honorable Mention Awards at ACM CHI 2026 (the premier HCI conference) and IEEE VIS 2023 (the premier data visualization conference). I have also been invited to present my work at leading conferences in the computational social science and network science communities, such as <a href="https://www.netsci2026.com/" target="_blank" rel="external">NetSci</a>, <a href="https://ic2s2-2026.org/" target="_blank" rel="external">IC2S2</a>{' '}
                and <a href="https://www.icssi.org" target="_blank" rel="external">ICSSI</a>. My research has been covered by&nbsp;
                <a href="https://www.nature.com/articles/d41586-025-03120-6" target="_blank" rel="external"><img src={NatureLogoRawUrl}
                        alt="Nature"
                        style={
                            {
                                height: '1em',
                                verticalAlign: 'middle',
                                marginRight: '0.2em'
                            }
                        }/></a>,&nbsp;
                <a href="https://www.science.org/content/article/ai-enters-grant-game-picking-winners" target="_blank" rel="external"><img src={ScienceLogoTransparentUrl}
                        alt="Science"
                        style={
                            {
                                height: '1em',
                                verticalAlign: 'middle',
                                marginRight: '0.2em'
                            }
                        }/></a>,&nbsp;
                <a href="https://www.microsoft.com/en-us/research/publication/interaction-augmented-instruction-modeling-the-synergy-of-prompts-and-interactions-in-human-genai-collaboration/" target="_blank" rel="external">
                <img src={MicrosoftResearchLogoUrl}
                    alt="Microsoft Research"
                    style={
                        {
                            height: '1.2em',
                            verticalAlign: 'middle',
                            marginRight: '0.2em'
                        }
                    }/>
                    </a>, and more. Beyond my primary research, I also create internationally exhibited <Link to="/dataArtPage" className='tooltip'>data-driven art</Link>, turning data into a medium for reflection on AI, technology and society — asking not only what technologies can do, but what they should mean for us.
            </p>
            <p> {/* The interdisciplinary nature of her research and her experience in <span style={{ textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: '4px' }}>computer science</span> and <span style={{ textDecoration: 'underline', textDecorationStyle: 'dotted', textUnderlineOffset: '4px' }}>business school</span> has also led her to actively engage across multiple research communities, working with over 50 researchers from fields such as network science, sociology, communication, and media art, and others, covering areas like the */}
                {/* The interdisciplinary nature of her research has led her to become an active participant in computer science, computational social science, and art communities, collaborating with more than fifty researchers from different fields, such as network science, sociology, communication, humanities, media art, and others, covering areas like the  */}
                {/* <Tooltip placement="right" title={SciSciIntro} className='tooltip'>
          <a href="https://www.science.org/doi/10.1126/science.aao0185" target="_blank" rel="external" className='highlight'> science of science and innovation (SciSci)</a>
        </Tooltip>
        ,
        <Tooltip placement="right" title={socialMobilityIntro} className='tooltip'>
          <a href="https://www.nature.com/articles/s41586-022-04996-4" target="_blank" rel="external" className='highlight'> social mobility and inequity</a>
        </Tooltip>
        ,
        public health, and more. */}
                {/* She also works closely with policy stakeholders on real-world societal decision-making problems, including funding agencies, venture capital firms, and leaders from top-tier universities. */}
                {/* These partnerships ensure her research is not only academically rigorous but also impactful and attuned to real-world decision-making needs. */}
                {/* (e.g., <a href="https://www.afrl.af.mil/AFOSR/" target="_blank" rel="external">AFOSR</a> and <a href="https://www.nsf.gov/" target="_blank" rel="external">NSF</a>) */}
                {/* (e.g., <a href="https://deerfield.com/" target="_blank" rel="external">Deerfield</a>) */}
                {/* In addition, she is also interested in exploring <span className='css-framework-step' style={{ color: '#26428B'}}>Data-driven Art</span>, to invite reflection, provoke emotion, and encourage public discussion around latest technology and social issues.
        The outcomes of her research include not only use-inspired visual analytics systems for decision-makers and social scientists, but also data-driven artworks that intuitively convey insights to the general public. */}


                {/* Here are some example problems that I think will contribute to this question:
         <ul>
          <li>
            <span className='css-framework-step' style={{ color: '#26428B'}}>Human-GenAI Collaboration.</span>
            How can we innovate new design paradigms and develop new visualization techniques for data science in the age of generative AI?
            With the development of large language models and AI agents, we can now explore data with natural language queries. But how can we leverage this to advance general data-driven tasks?
            Examples include: SciSciGPT and Interaction-Augmented Instructions for GenAI.
          </li>
          <li>
            <span className='css-framework-step' style={{ color: '#26428B'}}>HAI4Decision-Making.</span>
            How can we build data-driven HAI systems to assist decision-making in high-stakes societal problems?
            Real-world decision-making entails analyzing complex social issues and human behaviors to inform high-stakes, long-term choices, such as efforts by funding agencies to optimize research portfolios or urban planners to address social segregation. While massive data has revolutionized our understanding of these problems, its complexity and heterogeneity still pose challenges that traditional methods cannot easily overcome.
            Examples include: InnovationInsights (Science of Science) and FundingTheFrontier (Science Policy-Making).
          </li>
          <li>
            <span className='css-framework-step' style={{ color: '#26428B'}}>HAI4Science.</span>
            How can we leverage AI and involve human in the explorationloop to advance scientific discovery across various disciplines?
            AI has reshaped the way we do science (e.g., AlphaFold and GNoME), but many complex problems cannot be solved by AI alone. How can we combine the power of AI and knowledge from human scientists to advance scientific discovery across various disciplines?
            Examples include: HealthPrism (Public Health), InclusiViz (Sociology) and CareerLens (Digital Humanities).
          </li>
        </ul> */} </p>

            <p>Before joining FSU, I was a Post-Doctoral Fellow in the <a href="https://www.kellogg.northwestern.edu/research/science-of-science.aspx" target="_blank" rel="external">Center for Science of Science &amp; Innovation (CSSI)</a> at Kellogg School of Management,
                {' '}<a href="https://www.northwestern.edu/" target="_blank" rel="external">Northwestern University</a> with <a href="https://www.dashunwang.com/" target="_blank" rel="external">Prof. Dashun WANG</a>.
                                                                                                                                                                                                                                                                                                                                                                                                                                            I obtained a Ph.D. degree in the Department of Computer Science and Engineering from The Hong Kong University of Science and Technology (HKUST, 2022), at <a href="http://vis.cse.ust.hk/index.html" target="_blank" rel="external">HKUST VisLab</a> supervised by <a href="http://huamin.org/" target="_blank" rel="external">Prof. Huamin QU</a>, and a B.Eng. degree in the College of Computer Science and Technology from <a href="http://www.zju.edu.cn/" target="_blank" rel="external">Zhejiang University</a> (ZJU, 2018), at the <a href="http://zjuidg.org/" target="_blank" rel="external">ZJUIDG Group</a> supervised by <a href="http://www.ycwu.org/" target="_blank" rel="external">Prof. Yingcai WU</a>. {/* in the <a href="http://www.cad.zju.edu.cn/" target="_blank" rel="external">State Key Lab of CAD &amp; CG</a>,  */} </p>
            {/* <p>Her research interests lie broadly in visual analytics of computational social science (e.g.,
        <Tooltip placement="right" title={SciSciIntro} className='tooltip'>
          <a href="https://www.science.org/doi/10.1126/science.aao0185" target="_blank" rel="external" className='highlight'> Science of Science & Innovation</a>
        </Tooltip>
        ,
        <Tooltip placement="right" title={socialMobilityIntro} className='tooltip'>
          <a href="https://www.nature.com/articles/s41586-022-04996-4" target="_blank" rel="external" className='highlight'> Social Mobility & Inequity</a>
        </Tooltip>
        , and Public Health) and digital humanities.

        She also explores
        <Tooltip placement="right" title={dataArtIntro} className='tooltip'>
          <a href="https://en.wikipedia.org/wiki/Information_art" target="_blank" rel="external" className='highlight'> data-driven art</a>
        </Tooltip>
        , data storytelling, and immersive visual analytics with AR & VR. </p> */}
            {/* <p> Her current research focus is visual analytics for the
        <Tooltip placement="right" title={SciSciIntro} className='tooltip'>
          <a href="https://www.science.org/doi/10.1126/science.aao0185" target="_blank" rel="external" className='highlight'> Science of Science & Innovation</a>
        </Tooltip>
        , aiming to apply visualization, AI, and data analysis techniques to facilitate scientific discoveries and decision-making for the scientific community and the broader society.</p> */}
            {/* <p>Her research interests lie broadly in visual analytics of computational social science and digital humanities. She is also interested in data-driven art, data storytelling, immersive visual analytics with AR & VR, and visual anomaly detection. Her current research focuses include visual analytics of
        <Tooltip placement="right" title={SciSciIntro} className='tooltip'>
          <a href="https://www.science.org/doi/10.1126/science.aao0185" target="_blank" rel="external" className='highlight'> Science of Science</a>
        </Tooltip>
        ,
        <Tooltip placement="right" title={socialMobilityIntro} className='tooltip'>
          <a href="https://www.nature.com/articles/s41586-022-04996-4" target="_blank" rel="external" className='highlight'> Social Mobility and Inequity</a>
        </Tooltip>
        , and
        <Tooltip placement="right" title={dataArtIntro} className='tooltip'>
          <a href="https://en.wikipedia.org/wiki/Information_art" target="_blank" rel="external" className='highlight'> dara-driven art </a>
        </Tooltip>
        about social science and humanities.</p> */}
            {/* <p>She is a computer scientist, computational social scientist, and data artist. </p> */}
            <p>I enjoy photography, music, and observing life. {/* add an icon in antd to link to the lifePage --  a router */}
                {/* <Link to="/lifePage">
            &nbsp;<span className='highlight-life'>Yifang's Glimpse of Life </span>
            <img src={youtubeIconUrlsm} style={{height: '1.3em'}}/>
         </Link> */}
                {/* <a href='/lifePage'><img src={youtubeIconUrlsm} style={{height: '1.5em'}}/></a>.  */}
                {/* She is also a <a href='https://500px.com.cn/yifangwang'>photographer <img src={photoIconUrlsm} style={{height: '1.5em'}}/></a>, <a href='https://www.youtube.com/watch?v=hkT2pYdimPQ&list=PLPvA04rAJ83mw84oCIcVBrzZFBf912PZv'>music enthusiast <img src={youtubeIconUrlsm} style={{height: '1.5em'}}/></a>, and <a href='https://www.youtube.com/watch?v=JOLXq997Hr4&list=PLPvA04rAJ83lr3p24mOcaGtbLe0-qVJmb'>life watcher <img src={youtubeIconUrlsm} style={{height: '1.5em'}}/></a>.  */}
                {/* She is always seeking and exploring a balance of sense and sensibility, in both research and life.  */} </p>
            {/* recruiting: set like the Research overview — a heavy headline on the left, the details on the right */}
            <aside className='recruit' aria-label='Now recruiting'>
                <p className='recruit-big'><span className='recruit-dot' aria-hidden='true' />Now recruiting Ph.D. students</p>
                <div className='recruit-side'>
                    <p>I'm actively seeking Ph.D. students <mark>(multiple positions for Fall 2027)</mark>, master's students, undergraduate students, as well as visiting scholars and interns to join my research group. Students with backgrounds in <b>AI agents, generative AI, AI for science, or data visualization</b> are especially encouraged to apply.</p>
                    <Link to='/recruitingPage' className='recruit-cta'>Work with me <span aria-hidden='true'>→</span></Link>
                </div>
            </aside>
        </div>,
        profileImageUrl: yifangUrl
    },
    researchThemePage: [
        {
            title: 'Scientific Discovery',
            researchQuestion: 'How can we combine AI and human expertise to accelerate scientific discovery across various disciplines?',
            introduction: 'AI has reshaped the way we do science (e.g., AlphaFold and GNoME), yet many complex problems cannot be solved by AI alone. The key lies in combining AI\'s computational power with human knowledge to drive breakthroughs in diverse fields.',
            // How can we combine the power of AI and knowledge from human scientists to advance discovery across various fields?
            paperList: [
              {
                title: 'Figures as Interfaces: Toward LLM-Native Artifacts for Scientific Discovery',
                venueShort: 'arXiv',
                year: 2026
              },
              {
                title: 'SciSciGPT: Advancing Human-AI Collaboration in the Science of Science (Nature Cover Awards)',
                venueShort: 'Nature Computational Science',
                year: 2026
              },
              // {
              //   title: 'EMINDS: Understanding User Behavior Progression for Mental Health Exploration on Social Media',
              //   venueShort: 'IEEE TVCG',
              //   year: 2025
              // },
              //   {
              //       title: 'HealthPrism: A Visual Analytics System for Exploring Children\'s Physical and Mental Health Profiles with Multimodal Data',
              //       venueShort: 'IEEE VIS',
              //       year: 2023
              //   },
                // {
                //     title: 'InclusiViz: Visual Analytics of Human Mobility Data for Understanding and Mitigating Urban Segregation',
                //     venueShort: 'IEEE TVCG',
                //     year: 2025
                // },
            ],
            teaser: NatureSciSciGPTCoverUrl, // HAI4ScienceUrl
        },
        {
            title: 'High-stake Decision-Making',
            researchQuestion: 'How can we build data-driven HAI systems to assist decision-making in high-stakes societal problems?',
            introduction: 'Real-world problems (e.g., optimize funding allocation and facilitate translational research) demand analyzing complex social issues and human behaviors to inform high-stakes, long-term choices. While massive data has revolutionized our understanding of these problems, its scale and heterogeneity demand methods beyond traditional approaches.',
            paperList: [
              {
                title: 'FundingTheFrontier: Visualizing the Broad Impact of Science and Science Funding (Nature News Coverage)',
                venueShort: 'arXiv',
                year: 2025
              },
                {
                    title: 'InnovationInsights: A Visual Analytics Approach for Understanding the Dual Frontiers of Science and Technology (Best Paper Honorable Mention Awards)',
                    venueShort: 'IEEE VIS',
                    year: 2023
                }
            ], // InnovationInsights (Science of Science) and FundingTheFrontier (Science Policy-Making).
            teaser: HAI4DecisionMakingUrl
        },
        {
            title: 'Human-Agent Design Paradigm',
            researchQuestion: 'How can we innovate new design paradigms and visualization techniques in the age of generative AI?',
            introduction: 'With the development of large language models and AI agents, we can now explore data with natural language queries. But how can we leverage this to advance general data-driven tasks?',
            paperList: [
              {
                title: 'Interaction-Augmented Instruction: Modeling the Synergy of Prompts and Interactions in Human-GenAI Collaboration (Best Paper Honorable Mention Awards)',
                venueShort: 'ACM CHI',
                year: 2026
              },
                {
                    title: 'Prompting Generative AI with Interaction-Augmented Instructions',
                    venueShort: 'ACM CHI (LBW)',
                    year: 2025
                }
            ],
            teaser: HumanGenAIUrl
        }
    ],
    researchPage: [
        {
          isNew: true,
          category: [
              paperCategory.ALL, paperCategory.DR,
          ],
          teaser: AIDanceTeaserUrl,
          title: 'Effort',
          authorList: [
              'Junxiu Tang',
              'Hanna Renedo',
              'Yifang Wang',
              'Dashun Wang',
          ],
          venue: 'Conference on Neural Information Processing Systems',
          venueShort: 'NeurIPS2026 (Creative AI Track)',
          award: '',
          suppMaterialList: [
              {
                  name: 'PDF',
                  fileLink: AIDancePDFUrl
              },
              {name: 'Demo Video', fileLink: AIDanceVideoUrl},
          ]
        },
        {
          isNew: false,
          category: [
              paperCategory.ALL, paperCategory.LLM, paperCategory.CSS,
          ],
          teaser: MAADGTeaserUrl,
          title: 'MAADG: A Multi-Agent Framework for On-Demand Interactive Visualization Generation in Web-Based Education',
          authorList: [
            'Qiyuan Liu†',
            'Jinglin Hu†',
            'Yifang Wang',
            'Yushun Dong',
          ],
          venue: 'IEEE VIS 2026 (VISxGenAI Workshop)',
          venueShort: 'VIS2026 (Workshop)',
          award: '',
          suppMaterialList: [
              // {name: 'Project Page', fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'},
              {
                  name: 'PDF',
                  fileLink: MAADGPDFUrl
              },
              // {name: 'Supp Material', fileLink: MAADGPDFSIUrl},
              // {name: 'Preview Video (30s)', fileLink: ArtAnnoVideoPreviewUrl},
              // {name: 'Demo Video', fileLink: ArtAnnoVideoUrl},
              // {name: 'Slides (VIS 2023)', fileLink: InnovationInsightsSlidesUrl},
              // {name: 'Talk (VIS 2023)', fileLink: 'https://www.youtube.com/watch?v=YxSExcb6vAQ'},
              // {name: 'Poster (ChinaVis 2024)', fileLink: InclusionVizPosterUrl},
              // {name: 'Oral Talk (IC2S2 2024)', fileLink: '#'},
          ]
        },
        {
          isNew: true,
          category: [
              paperCategory.ALL, paperCategory.LLM, paperCategory.FEATURED, paperCategory.CSS,
          ],
          teaser: ArtAnnoUrl,
          title: 'ArtAnno: Annotating Implicit Semantics in Artworks through LLM Agent-Driven Bidirectional Human-AI Augmentation',
          authorList: [
              'Xiaoyan Gu†‡',
              'Yifang Wang‡',
              'Wenqing Zheng',
              'Haozhong Liu',
              'Yixia Zheng',
              'Peiyi Jiang',
              'Wenjie Ning',
              'Wei Zhang',
              'Wei Chen',
          ],
          venue: 'ACM Symposium on User Interface Software and Technology',
          venueShort: 'UIST2026',
          award: '',
          suppMaterialList: [
              // {name: 'Project Page', fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'},
              {
                  name: 'PDF',
                  fileLink: ArtAnnoPDFUrl
              },
              {name: 'Supp Material', fileLink: ArtAnnoPDFSIUrl},
              {name: 'Preview Video (30s)', fileLink: ArtAnnoVideoPreviewUrl},
              {name: 'Demo Video', fileLink: ArtAnnoVideoUrl},
              // {name: 'Slides (VIS 2023)', fileLink: InnovationInsightsSlidesUrl},
              // {name: 'Talk (VIS 2023)', fileLink: 'https://www.youtube.com/watch?v=YxSExcb6vAQ'},
              // {name: 'Poster (ChinaVis 2024)', fileLink: InclusionVizPosterUrl},
              // {name: 'Oral Talk (IC2S2 2024)', fileLink: '#'},
          ]
        },
        {
          category: [
              paperCategory.ALL, paperCategory.VA, paperCategory.LLM, paperCategory.HEALTH,
          ],
          teaser: DietGlanceUrl,
          title: 'DietGlance: Dietary Monitoring and Personalized Analysis at a Glance with Knowledge-Empowered AI Assistant',
          authorList: [
              'Zhihan Jiang†',
              'Running Zhao',
              'Lin Lin',
              'Yue Yu†',
              'Handi Chen',
              'Xinchen Zhang',
              'Xuhai Xu',
              'Yifang Wang',
              'Xiaojuan Ma',
              'Edith C.H. Ngai'
          ],
          venue: 'ACM Transactions on Computing for Healthcare',
          venueShort: 'HEALTH2026',
          award: '',
          suppMaterialList: [
              // {name: 'Project Page', fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'},
              {
                  name: 'PDF',
                  fileLink: DietGlancePDFUrl
              },
              // {name: 'Supp Material', fileLink: InclusiVizSuppUrl},
              // {name: 'Slides (VIS 2023)', fileLink: InnovationInsightsSlidesUrl},
              // {name: 'Talk (VIS 2023)', fileLink: 'https://www.youtube.com/watch?v=YxSExcb6vAQ'},
              // {name: 'Poster (ChinaVis 2024)', fileLink: InclusionVizPosterUrl},
              // {name: 'Oral Talk (IC2S2 2024)', fileLink: '#'},
          ]
        },
        {
          category: [
              paperCategory.ALL, paperCategory.FEATURED, paperCategory.LLM, paperCategory.AI4Sci,
          ],
          teaser: LLMNativeFigureUrl,
          title: 'Figures as Interfaces: Toward LLM-Native Artifacts for Scientific Discovery',
          isNew: true,
          authorList: [
              'Yifang Wang',
              'Rui Sheng',
              'Erzhuo Shao',
              'Yifan Qian',
              'Haotian Li',
              'Nan Cao',
              'Dashun Wang'
          ],
          venue: 'arXiv',
          venueShort: 'arXiv2026',
          award: '',
          suppMaterialList: [
            {name: 'Project Page', fileLink: 'https://llm-native-figure.com/'},
            { name: 'PDF', fileLink: 'https://arxiv.org/abs/2604.08491' },
            // {name: 'Supp Material', fileLink: InclusiVizSuppUrl},
            { name: 'Demo Video', fileLink: LLMNativeFigureVideoUrl },
            { name: 'Concept Film', fileLink: LLMNativeFigureConceptFilmUrl },
            { name: 'Poster (NetSci 2026)', fileLink: LLMNativeFigurePosterUrl }
          ]
        },
        {
          category: [
              paperCategory.ALL, paperCategory.LLM, paperCategory.AI4Sci,
          ],
          teaser: SurveyHAITeaserUrl,
          title: 'A Survey of Human-AI Collaboration for Scientific Discovery',
          authorList: [
            'Chuhan Shi', 'Xiaoquan Ren†', 'Yifang Wang', 'Junze Li', 'Yushi Sun', 'Yawen Luo', 'Rui Sheng'
          ],
          venue: 'arXiv',
          venueShort: 'arXiv2026',
          award: '',
          suppMaterialList: [
              {
                  name: 'PDF',
                  fileLink: SurveyHAIPDFUrl
              },
              // {name: 'Supp Material', fileLink: 'https://arxiv.org/abs/2502.01317'},
              // {name: 'Slides', fileLink: 'https://arxiv.org/abs/2502.01317'},
              // {name: 'Talk', fileLink: 'https://arxiv.org/abs/2502.01317'},
          ]
        },
        {
          category: [
              paperCategory.ALL, paperCategory.LLM
          ],
          teaser: GenIAITeaserUrl,
          title: 'Situated and Dynamic Human-AI Communication through Generative Interaction-Augmented Instruction at Runtime',
          authorList: [
              'Haotian Li',
              'Leixian Shen',
              'Yifang Wang',
          ],
          venue: 'CHI 2026 Workshop on Generative UI for HCI Practice',
          venueShort: 'CHI2026 (Workshop)',
          award: '',
          suppMaterialList: [
              {
                  name: 'PDF',
                  fileLink: GenIAIPDFUrl
              },
              { name: 'Workshop Page', fileLink: 'https://genuimeetshci.github.io/chi26-workshop/' },
          ]
        },
        {
          category: [
              paperCategory.ALL, paperCategory.FEATURED, paperCategory.LLM
          ],
          teaser: IAIUrl,
          title: 'Interaction-Augmented Instruction: Modeling the Synergy of Prompts and Interactions in Human-GenAI Collaboration',
          authorList: [
              'Leixian Shen†',
              'Yifang Wang',
              'Xing Xie',
              'Huamin Qu',
              'Haotian Li',
          ],
          venue: 'Proceedings of the SIGCHI Conference on Human Factors in Computing Systems',
          venueShort: 'CHI2026',
          award: 'CHI 2026 Honourable Mention Award',
          suppMaterialList: [
              {
                  name: 'PDF',
                  fileLink: 'https://arxiv.org/abs/2510.26069'
              },
              { name: 'Project Page', fileLink: "https://interaction-augmented-instruction.github.io/" },
              // {name: 'Supp Material', fileLink: 'https://arxiv.org/abs/2502.01317'},
              // {name: 'Slides', fileLink: 'https://arxiv.org/abs/2502.01317'},
              // {name: 'Talk', fileLink: 'https://arxiv.org/abs/2502.01317'},
          ]
        },
        {
          category: [
            paperCategory.ALL, paperCategory.CSS, paperCategory.VA, paperCategory.LLM
          ],
          teaser: DAVATeaserUrl,
          title: 'DAVA: Decoding Art with Visual Analytics through Feature Modeling and Multi-Agent Collaboration',
          authorList: [
            'Wei Zhang', 'Xiaoyan Gu†', 'Hengru Liu', 'Peiyi Jiang', 'Xianfeng Peng',
            'Zhenqian Xu', 'Yifang Wang*', 'Wei Chen*'
          ],
          venue: 'IEEE Transactions on Visualization and Computer Graphics',
          venueShort: 'TVCG2026',
          award: '',
          suppMaterialList: [
            {
              name: 'PDF',
              fileLink: DAVAPDFUrl
            },
            {
              name: 'Demo Video',
              fileLink: DAVAVideoUrl
            },
            {
              name: 'Supp Material',
              fileLink: DAVASIUrl
            }
          ]
        },
        {
          category: [
              paperCategory.ALL, paperCategory.FEATURED, paperCategory.CSS, paperCategory.VA, paperCategory.HEALTH, paperCategory.AI4Sci,
          ],
          teaser: FtFUrl,
          title: 'Funding the Frontier: Visualizing the Broad Impact of Science and Science Funding',
          authorList: [
              'Yifang Wang',
              'Yifan Qian',
              'Xiaoyu Qi',
              'Yian Yin',
              'Shengqi Dang',
              'Ziqing Qian',
              'Benjamin F. Jones',
              'Nan Cao',
              'Dashun Wang'
          ],
          venue: 'Nature Human Behaviour (to appear)',
          venueShort: 'NHB2026',
          award: '',
          suppMaterialList: [
              {
                  name: 'PDF',
                  fileLink: 'https://arxiv.org/abs/2509.16323'
              },
              // {name: 'Demo Video', fileLink: SciSciGPTVideo},
              // {name: 'Online System', fileLink: 'https://sciscigpt.com/'},
              {
                  name: 'Media Coverage (PDF)',
                  fileLink: FtFNewsPDFUrl
              }, {
                  name: 'Media Coverage',
                  fileLink: {
                    'Nature': 'https://www.nature.com/articles/d41586-025-03120-6',
                    // 'Chemistry World': 'https://www.chemistryworld.com/news/ai-tool-paints-bigger-picture-of-global-impact-of-millions-of-research-grants-papers-and-patents/4022383.article'
                  },
              },

          ]
        },
        {
            category: [
                paperCategory.ALL, paperCategory.FEATURED, paperCategory.CSS, paperCategory.LLM, paperCategory.AI4Sci,
            ],
            teaser: NatureSciSciGPTCoverUrl,
            // teaser: SciSciGPTUrl,
            teaserCrop: true, // the cover is cropped to a 16:10 frame
            title: 'SciSciGPT: Advancing Human-AI Collaboration in the Science of Science',
            authorList: [
                'Erzhuo Shao†',
                'Yifang Wang',
                'Yifan Qian',
                'Zhenyu Pan',
                'Han Liu',
                'Dashun Wang'
            ],
            venue: 'Nature Computational Science',
            venueShort: 'NCS2026',
            award: '',
            suppMaterialList: [
                {
                  name: 'PDF',
                    fileLink: 'https://www.nature.com/articles/s43588-025-00906-6'
                }, {
                  name: 'Research Briefing',
                  fileLink: 'https://www.nature.com/articles/s43588-025-00935-1'
                },
                {
                  name: 'Poster',
                  fileLink: SciSciGPTPosterUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: SciSciGPTVideo
                }, {
                    name: 'Online System',
                    fileLink: 'https://sciscigpt.com/'
                },
                {
                  name: 'Code Repository',
                  fileLink: "https://github.com/Northwestern-CSSI/SciSciGPT"
                },
                {
                  name: 'Journal Cover Design',
                  fileLink: 'https://www.nature.com/natcomputsci/volumes/6/issues/3',
                },
                {
                  name: 'Media Coverage',
                  fileLink: {
                    'Nature': 'https://www.nature.com/articles/d41586-026-00665-y',
                  },
                }
            ]
        },
        {
          category: [
            paperCategory.ALL, paperCategory.FEATURED, paperCategory.CSS, paperCategory.VA, paperCategory.HEALTH,
          ],
          teaser: EMINDSUrl,
          title: 'EMINDS: Understanding User Behavior Progression for Mental Health Exploration on Social Media',
          authorList: [
            'Rui Sheng†',
            'Yifang Wang*',
            'Xingbo Wang',
            'Shun Dai',
            'Qingyu Guo',
            'Tai-Quan Peng',
            'Huamin Qu',
            'Dongyu Liu*'
          ],
          venue: 'IEEE Transactions on Visualization and Computer Graphics',
          venueShort: 'TVCG2025',
          award: '',
          suppMaterialList: [
            {
              name: 'PDF',
              fileLink: EMINDSPDFUrl
            }
          ]
        },
        {
            category: [
                paperCategory.ALL, paperCategory.LLM
            ],
            teaser: PromptingGenerativeAIUrl,
            title: 'Prompting Generative AI with Interaction-Augmented Instructions',
            authorList: [
                'Leixian Shen†',
                'Haotian Li',
                'Yifang Wang',
                'Xing Xie',
                'Huamin Qu'
            ],
            venue: 'Proceedings of the SIGCHI Conference on Human Factors in Computing Systems, Late-Breaking Work (LBW)',
            venueShort: 'CHI2025 (LBW)',
            award: '',
            suppMaterialList: [
                {
                    name: 'PDF',
                    fileLink: 'https://arxiv.org/abs/2503.02874'
                },
                // {name: 'Supp Material', fileLink: 'https://arxiv.org/abs/2502.01317'},
                // {name: 'Slides', fileLink: 'https://arxiv.org/abs/2502.01317'},
                // {name: 'Talk', fileLink: 'https://arxiv.org/abs/2502.01317'},
            ]
        },
        {
            category: [
                paperCategory.ALL, paperCategory.DR
            ],
            teaser: ISEA2025_Three_in_OneUrl,
            title: 'Behind the Molecules: An Alternative Data Visualization to Critic Chemical Abuse in Food Production',
            authorList: [
                'Han-Lu Ma†',
                'Zi-Wei Wu†',
                'Mengying Du',
                'Burak Korkmaz',
                'Xiaofu Jin',
                'Yifang Wang',
                'Huamin Qu'
            ],
            venue: 'Proceedings of the International Symposium on Electronic Art',
            venueShort: 'ISEA2025',
            award: '',
            suppMaterialList: [
                {
                    name: 'PDF',
                    fileLink: ISEA2025_Three_in_OnePaperUrl
                },
                // {name: 'Supp Material', fileLink: 'https://arxiv.org/abs/2502.01317'},
                // {name: 'Slides', fileLink: 'https://arxiv.org/abs/2502.01317'},
                // {name: 'Talk', fileLink: 'https://arxiv.org/abs/2502.01317'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.DR
            ],
            teaser: ISEA2025_PentobarbitalUrl,
            title: 'Hidden Incidents of Animal Euthanasia: Exploring Kinship under Dominance and Affection',
            authorList: [
                'Zi-Wei Wu†',
                'Dan-Lu Fei',
                'Burak Korkmaz',
                'Xiaofu Jin',
                'Wen You',
                'Yifang Wang',
                'Kang Zhang'
            ],
            venue: 'Proceedings of the International Symposium on Electronic Art',
            venueShort: 'ISEA2025',
            award: '',
            suppMaterialList: [
                {
                    name: 'PDF',
                    fileLink: ISEA2025_PentobarbitalPaperUrl
                },
                // {name: 'Supp Material', fileLink: 'https://arxiv.org/abs/2502.01317'},
                // {name: 'Slides', fileLink: 'https://arxiv.org/abs/2502.01317'},
                // {name: 'Talk', fileLink: 'https://arxiv.org/abs/2502.01317'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.VA
            ],
            teaser: InclusiVizUrl,
            title: 'InclusiViz: Visual Analytics of Human Mobility Data for Understanding and Mitigating Urban Segregation',
            authorList: [
                'Yue Yu†',
                'Yifang Wang',
                'Yongjun Zhang',
                'Huamin Qu',
                'Dongyu Liu'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'PacificVis2025 (TVCG Journal Track)',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'},
                {
                    name: 'PDF',
                    fileLink: InclusionVizPaperUrl
                },
                // {name: 'Supp Material', fileLink: InclusiVizSuppUrl},
                // {name: 'Slides (VIS 2023)', fileLink: InnovationInsightsSlidesUrl},
                // {name: 'Talk (VIS 2023)', fileLink: 'https://www.youtube.com/watch?v=YxSExcb6vAQ'},
                {
                    name: 'Poster (ChinaVis 2024)',
                    fileLink: InclusionVizPosterUrl
                },
                // {name: 'Oral Talk (IC2S2 2024)', fileLink: '#'},
            ]
        }, {
            category: [paperCategory.ALL],
            teaser: ComparativeStudyUrl,
            title: 'A Comparative Study on Fixed-order Event Sequence Visualizations: Gantt, Extended Gantt, and Stringline Charts',
            authorList: [
                'Junxiu Tang†',
                'Fumeng Yang',
                'Jiang Wu',
                'Yifang Wang',
                'Jiayi Zhou',
                'Xiwen Cai',
                'Lingyun Yu',
                'Yingcai Wu'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'TVCG2024',
            award: '',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://osf.io/qdpzm/'
                }, {
                    name: 'PDF',
                    fileLink: ComparativeStudyPaperUrl
                },
            ]
        },{
            category: [
                paperCategory.ALL, paperCategory.DR
            ],
            teaser: lossGenerationUrl,
            title: 'Loss of Sonnet 18',
            authorList: [
                'Junxiu Tang†',
                'Jiayi Zhou†',
                'Yifang Wang',
                'Xinhuan Shu',
                'Peiquan Xia',
                'Xiaojiao Chen',
                'Tan Tang',
                'Yingcai Wu'
            ],
            venue: 'SIGGRAPH 2024, Art Gallery',
            venueShort: 'SIGGRAPH Art 2024',
            award: '',
            suppMaterialList: [
                {
                    name: 'PDF',
                    fileLink: 'https://dl.acm.org/doi/10.1145/3641523.3669939'
                }, {
                    name: 'Official Website',
                    fileLink: 'https://s2024.conference-program.org/presentation/?id=artg_205&sess=sess284'
                }, {
                    name: 'Demo Video',
                    fileLink: lossGenerationVideoUrl
                }, {
                    name: 'Slides',
                    fileLink: generationLossSlidesUrl
                },
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.DR
            ],
            teaser: CatVisUrl,
            title: '"Hidden Incidents of Pet Food": Portraying Taurine Deficiency in Cats',
            authorList: [
                'Ziwei Wu†',
                'Xiaofu Jin',
                'Danlu Fei',
                'Yifang Wang',
                'Guangda Zhu',
                'Kang Zhang'
            ],
            venue: 'The International Symposium on Electronic Art (the top conference in media art)',
            venueShort: 'ISEA2024',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: 'https://osf.io/qdpzm/'},
                {
                    name: 'PDF',
                    fileLink: CatVisPaperUrl
                },
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.FEATURED, paperCategory.VA, paperCategory.AI4Sci,
            ],
            teaser: InnovationInsightsUrl,
            title: 'InnovationInsights: A Visual Analytics Approach for Understanding the Dual Frontiers of Science and Technology',
            authorList: [
                'Yifang Wang',
                'Yifan Qian',
                'Xiaoyu Qi',
                'Nan Cao',
                'Dashun Wang'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'VIS2023',
            award: 'Best Paper Honorable Mention',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'
                },
                {
                    name: 'PDF',
                    fileLink: InnovationInsightsPaperUrl
                },
                {
                    name: 'Background Video',
                    fileLink: InnovationInsightsBackgroundBackgroundVideoUrl
                },
                {
                    name: 'Case Video',
                    fileLink: InnovationInsightsBackgroundCaseVideoUrl
                }, {
                    name: 'Supp Material',
                    fileLink: InnovationInsightsSuppUrl
                }, {
                    name: 'Slides (VIS 2023)',
                    fileLink: InnovationInsightsSlidesUrl
                }, {
                    name: 'Talk (VIS 2023)',
                    fileLink: 'https://www.youtube.com/watch?v=YxSExcb6vAQ'
                }, {
                    name: 'Poster (ICSSI 2023)',
                    fileLink: InnovationInsightsPosterUrl
                }, {
                    name: 'Media Coverage',
                    fileLink: {
                      'Nature': 'https://www.nature.com/articles/d41586-024-02081-6',
                      'Science': 'https://www.science.org/content/article/ai-enters-grant-game-picking-winners'
                    }
                },
                // {name: 'Oral Talk (IC2S2 2024)', fileLink: '#'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.FEATURED, paperCategory.VA, paperCategory.HEALTH,
            ],
            teaser: HealthPrismUrl,
            title: "HealthPrism: A Visual Analytics System for Exploring Children's Physical and Mental Health Profiles with Multimodal Data",
            authorList: [
                'Zhihan Jiang†',
                'Handi Chen',
                'Rui Zhou',
                'Jing Deng',
                'Xinchen Zhang',
                'Running Zhao',
                'Cong Xie',
                'Yifang Wang*',
                'Edith C.H. Ngai*'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'VIS2023',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'},
                {
                    name: 'PDF',
                    fileLink: HealthPrismPaperUrl
                }, {
                    name: 'Demo Video',
                    fileLink: HealthPrismVideoUrl
                },
                // {name: 'Slides', fileLink: '#'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.DR
            ],
            teaser: LonelyIslandUrl,
            title: 'Posts with no Response: The Island of Loneliness',
            authorList: [
                'Junxiu Tang†',
                'Rui Sheng†',
                'Yifang Wang',
                'Xinhuan Shu',
                'Xiaojiao Chen',
                'Tan Tang',
                'Yingcai Wu'
            ],
            venue: 'IEEE VIS Arts Program (accepted in two tracks: Pictorial and Artwork)',
            venueShort: 'VISAP2023',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: ''},
                {
                    name: 'PDF',
                    fileLink: LonelyIslandPaperUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: LonelyIslandVideoUrl
                },
                {
                    name: 'VISAP2023 Official Website',
                    fileLink: 'https://visap.net/2023/contributions/posts-with-no-response-the-island-of-loneliness'
                },
                {
                    name: 'Info+ 2023 Official Website',
                    fileLink: 'https://informationplusconference.com/2023/#program'
                },
                // {name: 'Slides', fileLink: ACSeekerSlidesUrl},
                // {name: 'Talk', fileLink: 'https://www.youtube.com/watch?v=y4UaKwzBeNY'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.VA
            ],
            teaser: NeighVizUrl,
            title: 'NeighViz: Towards Better Understanding of Neighborhood Effects on Social Groups with Spatial Data',
            authorList: [
                'Yue Yu†',
                'Yifang Wang*',
                'Qisen Yang†',
                'Di Weng',
                'Yongjun Zhang',
                'Xiaogang Wu',
                'Yingcai Wu',
                'Huamin Qu'
            ],
            venue: 'Visualization in Data Science (VDS at IEEE VIS)',
            venueShort: 'VDS2023',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: 'https://kellogg-cssi.github.io/InnovationInsights/'},
                {
                    name: 'PDF',
                    fileLink: NeighVizPaperUrl
                },
                // {name: 'Case Video', fileLink: InnovationInsightsBackgroundCaseVideoUrl},
                {
                    name: 'Supp Material',
                    fileLink: NeighVizSuppUrl
                },
                // {name: 'ICSSI2023 Poster', fileLink: InnovationInsightsPosterUrl},
                // {name: 'Slides', fileLink: ACSeekerSlidesUrl},
                // {name: 'Talk', fileLink: 'https://www.youtube.com/watch?v=y4UaKwzBeNY'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.DH
            ],
            teaser: TCKUrl,
            title: 'Computational Approaches for Traditional Chinese Painting: From the "Six Principles of Painting" Perspective',
            authorList: [
                'Wei Zhang†',
                'Jianwei Zhang',
                'Jason Wong',
                'Yifang Wang',
                'Yingchaojie Feng',
                'Luwei Wang',
                'Wei Chen'
            ],
            venue: 'Journal of Computer Science and Technology',
            venueShort: 'JCST2023',
            award: '',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://ca4tcp.com/'
                }, {
                    name: 'PDF',
                    fileLink: TCKPaperUrl
                }, {
                    name: 'Slides',
                    fileLink: '#'
                },
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.FEATURED, paperCategory.VA
            ],
            teaser: ACSeekerUrl,
            title: 'Seek for Success: A Visualization Approach for Understanding the Dynamics of Academic Careers',
            authorList: [
                'Yifang Wang',
                'Tai-Quan Peng',
                'Huihua Lu',
                'Haoren Wang',
                'Xiao Xie',
                'Huamin Qu',
                'Yingcai Wu'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'TVCG2022',
            award: '',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: './xxxxxx'
                },
                {
                    name: 'PDF',
                    fileLink: ACSeekerPaperUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: ACSeekerVideoUrl
                },
                {
                    name: 'Supp Material',
                    fileLink: ACSeekerSuppUrl
                }, {
                    name: 'Slides',
                    fileLink: ACSeekerSlidesUrl
                }, {
                    name: 'Talk',
                    fileLink: 'https://www.youtube.com/watch?v=y4UaKwzBeNY'
                },
            ]
        }, {
            category: [
                paperCategory.ALL,
                paperCategory.CSS,
                paperCategory.DH,
                // paperCategory.FEATURED,
                paperCategory.VA
            ],
            teaser: CareerLensUrl,
            title: 'Interactive Visual Exploration of Longitudinal Historical Career Mobility Data',
            authorList: [
                'Yifang Wang',
                'Hongye Liang',
                'Xinhuan Shu',
                'Jiachen Wang',
                'Ke Xu',
                'Zikun Deng',
                'Cameron Campbell',
                'Bijia Chen',
                'Yingcai Wu',
                'Huamin Qu'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'TVCG2022',
            award: '',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: './xxxxxx'
                },
                {
                    name: 'PDF',
                    fileLink: CareerLensPaperUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: CareerLensVideoUrl
                },
                {
                    name: 'Supp Material',
                    fileLink: CareerLensSuppUrl
                }, {
                    name: 'Slides',
                    fileLink: CareerLensSlidesUrl
                }, {
                    name: 'Talk',
                    fileLink: 'https://www.youtube.com/watch?v=jHhK1ajh96g'
                },
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.DH, paperCategory.DR
            ],
            teaser: visap2021Url,
            title: 'Explore Mindfulness without Deflection: A Data Art Based on the Book of Songs',
            authorList: [
                'Yifang Wang',
                'Yifan Cao',
                'Junxiu Tang',
                'Yang Wang',
                'Huamin Qu',
                'Yingcai Wu'
            ],
            venue: 'IEEE VIS Arts Program',
            venueShort: 'VISAP2021',
            award: '',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://wangyifang.github.io/the-book-of-songs/'
                },
                {
                    name: 'PDF',
                    fileLink: visap2021PaperUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: visap2021VideoUrl
                },
                {
                    name: 'Supp Material',
                    fileLink: visap2021SuppUrl
                }, {
                    name: 'Slides',
                    fileLink: visap2021SlidesUrl
                }, {
                    name: 'Talk',
                    fileLink: 'https://www.youtube.com/watch?v=5fNTfPpeXQs'
                },
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.VA
            ],
            teaser: mTSeerUrl,
            title: 'mTSeer: Interactive Visual Exploration of Models on Multivariate Time-series Forecast',
            authorList: [
                'Ke Xu',
                'Jun Yuan',
                'Yifang Wang',
                'Claudio Silva',
                'Enrico Bertini'
            ],
            venue: 'Proceedings of the SIGCHI Conference on Human Factors in Computing Systems',
            venueShort: 'CHI2021',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: './xxxxxx'},
                {
                    name: 'PDF',
                    fileLink: mTSeerPaperUrl
                }, {
                    name: 'Demo Video',
                    fileLink: './xxxxxx'
                },
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.VA
            ],
            teaser: CloudDetUrl,
            title: 'CloudDet: Interactive Visual Analysis of Anomalous Performances in Cloud Computing Systems',
            authorList: [
                'Ke Xu',
                'Yun Wang',
                'Leni Yang',
                'Yifang Wang',
                'Bo Qiao',
                'Si Qin',
                'Yong Xu',
                'Haidong Zhang',
                'Huamin Qu'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'VIS2020',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: './xxxxxx'},
                {
                    name: 'PDF',
                    fileLink: CloudDetPaperUrl
                }, {
                    name: 'Demo Video',
                    fileLink: './xxxxxx'
                },
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.VA
            ],
            teaser: pulseUrl,
            title: 'Pulse: Toward a Smart Campus by Communicating Real-time Wi-Fi Access Data',
            authorList: [
                'Aoyu Wu',
                'Bon Kyung Ku',
                'Furui Cheng',
                'Xinhuan Shu',
                'Abishek Puri',
                'Yifang Wang',
                'Huamin Qu'
            ],
            venue: 'Workshop on Visualization for Communication, the IEEE Visualization Conference',
            venueShort: 'VIS2018',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: './xxxxxx'},
                {
                    name: 'PDF',
                    fileLink: pulsePaperUrl
                },
                // {name: 'Demo Video', fileLink: './xxxxxx'},
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.IS
            ],
            teaser: MARVisTUrl,
            title: 'MARVisT: Authoring Glyph-based Visualization in Mobile Augmented Reality',
            authorList: [
                'Zhutian Chen',
                'Yijia Su',
                'Yifang Wang',
                'Qianwen Wang',
                'Huamin Qu',
                'Yingcai Wu'
            ],
            venue: 'IEEE Transactions on Visualization and Computer Graphics',
            venueShort: 'TVCG2019',
            award: '',
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://chenzhutian.org/marvist/'
                }, {
                    name: 'PDF',
                    fileLink: MARVisTPaperUrl
                }, {
                    name: 'Demo Video',
                    fileLink: './xxxxxx'
                },
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ]
        }, {
            category: [
                paperCategory.ALL, paperCategory.IS
            ],
            teaser: urbanARUrl,
            title: 'Exploring the design space of immersive urban analytics',
            authorList: [
                'Zhutian Chen',
                'Yifang Wang',
                'Tianchen Sun',
                'Xiang Gao',
                'Wei Chen',
                'Zhigeng Pan',
                'Huamin Qu',
                'Yingcai Wu'
            ],
            venue: 'Visual Informatics',
            venueShort: 'VA2017',
            award: '',
            suppMaterialList: [
                // {name: 'Project Page', fileLink: './xxxxxx'},
                {
                    name: 'PDF',
                    fileLink: urbanARPaperUrl
                },
                // {name: 'Demo Video', fileLink: './xxxxxx'},
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ]
        },
    ],
    workWithMePage: {
        introduction: {
            overview: 'We are always looking for motivated students and researchers from diverse backgrounds to join us!',
            researchAreas: {
                description: [
                    'Our research centers on', 'For example, our recent work focuses on innovating human-agent collaboration paradigms to help people better communicate with AI.', 'Another line of research focuses on building human-AI and visual systems to facilitate scientific discovery and science policy-making.', 'Ultimately, our goal is to harness the combined power of AI and human intelligence to advance scientific progress and support better decision-making that fosters human well-being and prosperity.',
                ],
                list: [
                    'data visualization',
                    'human-AI collaboration',
                    'generative AI',
                    'Agentic AI',
                    'AI for science',
                    'AI for decision-making'
                ]
            },
            publicationVenues: {
                cs: [
                    'IEEE TVCG', 'IEEE VIS', 'ACM CHI', 'ACM UIST'
                ],
                css: [
                    'NetSci', 'IC2S2', 'ICSSI'
                ],
                generalAudience: ['Nature Computational Science', 'Nature Human Behaviour'],
                art: ['IEEE VIS Arts Program (VISAP)', 'ACM Special Interest Group on Computer Graphics and Interactive Techniques (SIGGRAPH), Art Gallery', 'International Symposium on Electronic Art (ISEA)']
            },
            studentRequirements: {
                require: 'We welcome self-motivated students from diverse backgrounds, including but not limited to computer science, software engineering, data science, and related fields. Strong programming skills and solid mathematical foundations are highly recommended, as lacking of them would significantly hinder your progress.',
                plus: 'Beyond technical abilities, what matters most is self-motivation, interdisciplinary curiosity, and a genuine passion for research that brings social good, improves human and ecological well-being, and aspires to change the world. Above all, we seek students with the ambition to "dream the impossible dream, run where the brave dare not go, and reach the unreachable star" (quoted from Man of La Mancha) together with us.'
            }
        },
        contactInformation: {
            googleFormLink: '',
            emailAddress: ''
        },
        whyFSU: <>
            FSU is a top-tier research university with a world-class academic reputation. FSU is ranked
            <a href="https://news.fsu.edu/news/university-news/2025/09/23/florida-state-university-lauded-for-student-success-in-2026-u-s-news-best-colleges-rankings/" target="_blank" rel="external">51st</a>
            in the 2026 US News & World Report and
            <a href="https://www.niche.com/colleges/florida-state-university/" target="_blank" rel="external">11th</a>
            among public universities according to Niche. The university receives $200 million in research funding annually. Located near the beautiful Gulf of Mexico, FSU is surrounded by some of the best beaches and state park systems in the U.S. It is conveniently located near major cities including Atlanta and Orlando, making for an easy living and entertainment experience.
        </>
    },
    mediaCoveragePage: [
        {
          year: '2026',
          date: 'Mar 5, 2026',
          title: 'From Grants To Real-World Impact',
          description: 'Funding the Frontier maps how research funding moves through the scientific ecosystem and into society.',
          mediaName: 'NI Institute',
          mediaType: 'MEDIA',
          newsLink: ['https://www.niinstitute.org/press/new-platform-tracks-the-real-world-impact-of-research-funding?mc_cid=3fc220dd89&mc_eid=1e802df9a1'],
          paperLink: [FtFUrl],
          img: [NIFtFImageUrl]
        },
        {
          year: '2026',
          date: 'Mar 5, 2026',
          title: 'Finding The Innovators Hiding In Plain Sight',
          description: 'InnovationInsights helps universities identify research — and the faculty behind it — with strong commercialization potential.',
          mediaName: 'NI Institute',
          mediaType: 'MEDIA',
          newsLink: ['https://www.niinstitute.org/press/finding-the-innovators-hiding-in-plain-sight?mc_cid=3fc220dd89&mc_eid=1e802df9a1'],
          paperLink: [InnovationInsightsPaperUrl],
          img: [NIIIImageUrl]
        },
        {
          year: '2026',
          date: 'Mar 5, 2026',
          title: 'SciSciGPT: Using AI To Advance The Science of Science',
          description: 'An open-source AI research collaborator designed to automate complex analysis, accelerate discovery and support reproducible science.',
          mediaName: 'NI Institute',
          mediaType: 'MEDIA',
          newsLink: ['https://www.nature.com/articles/s43588-025-00906-6?mc_cid=3fc220dd89&mc_eid=1e802df9a1'],
          paperLink: [SciSciGPTUrl],
          img: [NISciSciGPTImageUrl]
        },
        {
          year: '2026',
          date: 'Mar 2, 2026',
          title: 'AI agents are ‘aeroplanes for the mind’: five ways to ensure that scientists are responsible pilots',
          description: 'As artificial-intelligence systems take on more of the scientific workflow, the central goal should not be complete automation, but designing platforms that preserve creativity, responsibility and surprise.',
          mediaName: 'Nature',
          mediaType: 'COMMENT',
          newsLink: ['https://www.nature.com/articles/d41586-026-00665-y'],
          paperLink: [SciSciGPTUrl],
          img: [NatureLogoUrl]
        },
        {
          year: '2026',
          date: 'Feb 20, 2026',
          title: 'Interaction-Augmented Instruction: Modeling the Synergy of Prompts and Interactions in Human-GenAI Collaboration',
          description: '',
          mediaName: 'Microsoft Research',
          mediaType: 'RESEARCH',
          newsLink: ['https://www.microsoft.com/en-us/research/publication/interaction-augmented-instruction-modeling-the-synergy-of-prompts-and-interactions-in-human-genai-collaboration/'],
          paperLink: [IAIUrl],
          img: [MSLogoUrl]
        },
        {
          year: '2026',
          date: 'Feb 19, 2026',
          title: 'Can we predict which chemistry research projects will pay off?',
          description: '',
          mediaName: 'Chemical & Engineering News (C&EN)',
          mediaType: 'NEWS',
          newsLink: ['https://cen.acs.org/physical-chemistry/predict-chemistry-research-projects-succeed/104/web/2026/02'],
          paperLink: [FtFUrl],
          img: [CENLogoUrl]
        },
        {
            year: '2026',
            date: 'Jan 16, 2026',
            title: 'Can a New GPT Accelerate Human–AI Collaboration in Science?',
            description: 'SciSciGPT takes on the tedious tasks so scientists can dream bigger.',
            mediaName: 'KelloggInsight',
            mediaType: 'NEWS',
            newsLink: ['https://insight.kellogg.northwestern.edu/article/can-a-new-gpt-accelerate-human-ai-collaboration-in-science?utm_source=newsletter&utm_medium=email'],
            paperLink: [SciSciGPTUrl],
            img: [KelloggInsightLogoUrl]
        },
        {
          year: '2025',
          date: 'Oct 28, 2025',
          title: 'AI tool paints bigger picture of global impact of millions of research grants, papers and patents',
          description: '',
          mediaName: 'Chemistry World',
          mediaType: 'NEWS',
          newsLink: ['https://www.chemistryworld.com/news/ai-tool-paints-bigger-picture-of-global-impact-of-millions-of-research-grants-papers-and-patents/4022383.article'],
          paperLink: [FtFUrl],
          img: [ChemistryWorldLogoUrl]
        },
        {
            year: '2025',
            date: 'Oct 1, 2025',
            title: 'Will your study change the world? This AI tool predicts the impact of your research',
            description: 'A tool called Funding the Frontier visualizes all the downstream impacts of funding — and predicts which studies will have the biggest societal impact.',
            mediaName: 'Nature',
            mediaType: 'NEWS',
            newsLink: ['https://www.nature.com/articles/d41586-025-03120-6'],
            paperLink: ['https://arxiv.org/abs/2509.16323'],
            img: [NatureLogoUrl]
        }, {
            year: '2025',
            date: 'Aug 29, 2025',
            title: 'AI enters the grant game, picking winners',
            description: 'Funders test algorithms to spot promising science, raising hopes of faster reviews—and fears of bias.',
            mediaName: 'Science',
            mediaType: 'NEWS',
            newsLink: ['https://www.science.org/content/article/ai-enters-grant-game-picking-winners'],
            paperLink: [InnovationInsightsPaperUrl],
            img: [ScienceLogoUrl]
        },
        // {
        // year: '2025',
        // date: '28 April 2025',
        // title: 'CHI: Prompting Generative AI with Interaction-Augmented Instructions',
        // mediaName: 'Microsoft Research',
        // mediaType: 'CONFERENCE',
        // newsLink: ['https://mp.weixin.qq.com/s/owoxoJAHLuhssOwchdcHWA'],
        // // paperLink: ['https://arxiv.org/abs/2509.16323'],
        // img: [MicrosoftResearchLogoUrl]
        // },
        {
            year: '2024',
            date: 'Jun 26, 2024',
            title: 'How I\'m using AI tools to help universities maximize research impacts',
            description: 'Artificial-intelligence algorithms could identify scientists who need support with translating their work into real-world applications and more. Leaders must step up.',
            mediaName: 'Nature',
            mediaType: 'WORLD VIEW',
            newsLink: ['https://www.nature.com/articles/d41586-024-02081-6'],
            paperLink: ['https://arxiv.org/abs/2509.16323'],
            img: [NatureLogoUrl]
        },
        // {
        // year: '2024',
        // date: '30 October 2024',
        // title: 'Altering Nature: Exploring Life in Computational Art',
        // mediaName: 'HKUST Library',
        // mediaType: 'EXIHIBITION',
        // newsLink: ['https://library.hkust.edu.hk/exhibitions/computational-art/'],
        // // paperLink: ['https://arxiv.org/abs/2509.16323'],
        // img: [HKUSTLibraryLogoUrl]
        // },
        // {
        // year: '2024',
        // date: '28 August 2024',
        // title: 'Backstory of the "Island of Loneliness"\n',
        // mediaName: 'HKUST Library',
        // mediaType: 'EXIHIBITION',
        // newsLink: ['https://library.hkust.edu.hk/sc/the-island-of-loneliness-china-visap/'],
        // img: [HKUSTLibraryLogoUrl]
        // }
    ],
    newsPage: [
      {
        date: 'Nov. 2026',
        content: '✈️ I\'m attending ACM UIST 2026 and IEEE VIS 2026 in Detroit and Boston. See you there!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.CONFERENCE],
        link: ['https://uist.acm.org/2026/', 'https://ieeevis.org/year/2026/welcome']
      },
      {
        date: 'Oct. 2026',
        content: '🌐 Our new project page on LLM-native figures is now online! Check it out at llm-native-figure.com!',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ['https://llm-native-figure.com/'],
        img: [LLMNativeFigureTeaserUrl]
      },
      {
        date: 'Sept. 2026',
        content: '🧑🏻‍🎨 Our artwork "Effort", exploring human-AI collaboration in generative choreography, has been accepted to the NeurIPS 2026 Creative AI Track!! See you in Dec. in Sydney, Australia!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.CONFERENCE],
        link: [AIDanceVideoUrl, AIDancePDFUrl, 'https://neurips.cc/Conferences/2026/CallForCreativeAI'],
        img: [AIDanceTeaserUrl]
      },
      {
        date: 'Sept. 2026',
        content: '🎉 Our paper "MAADG: A Multi-Agent Framework for On-Demand Interactive Visualization Generation in Web-Based Education," has been accepted to VIS x GenAI Workshop at IEEE VIS! See you in Boston in Nov. 2026!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.CONFERENCE],
        link: [MAADGPDFUrl, 'https://visxgenai.github.io/']
      },
      {
        date: 'Jul. 2026',
        content: '👥 Glad to be invited as a Associate Chair for CHI 2027 and a Program Committee member for AI4SciSci Workshop 2026!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.CONFERENCE],
        link: ['https://chi2027.acm.org/', 'https://ai4scisci.github.io/2026/']
      },
      {
        date: 'Jul. 2026',
        content: '🎉 Our paper on human-AI collaboration for agent skill evolution,  "ArtAnno: Annotating Implicit Semantics in Artworks through LLM Agent-Driven Bidirectional Human-AI Augmentation," has been accepted to UIST 2026! See you in Detroit, MI, USA, in Nov. 2026!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.CONFERENCE],
        link: ['http://arxiv.org/abs/2608.05026', 'https://uist.acm.org/2026/']
      },
      {
        date: 'Jul. 2026',
        content: '🎉 We are excited to welcome our new lab members: the wonderful Ph.D. student Hongxin Fu!!',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ['https://april-fu.com/']
      },
      {
        date: 'Jul. 2026',
        content: 'I\'m attending IC2S2 2026 (International Conference on Computational Social Science) at Burlington, Vermont and presented two working papers!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ['https://ic2s2-2026.org/'],
        img: [],
        location: 'Burlington, Vermont, USA',
      },
      {
        date: 'Jul. 2026',
        content: '💵 I have received a College of Arts and Sciences Dean\'s Faculty Travel Award at FSU for Fall 2026!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.AWARDS],
      },
      // hidden: the welcome with Qinshi Zhang (uncomment to show again; it replaces the one below)
      // {
      //   date: 'Jun. 2026',
      //   content: '🎉 We are excited to welcome our new lab members: the amazing Ph.D. student Qinshi Zhang and research interns Xinyi Li (UMich) and Chengran Xu (UW–Madison)!!',
      //   category: [newsCategory.ALL, newsCategory.IN2026],
      //   link: ['https://carolzhangzz.github.io/', 'https://adelinexinyi.github.io/', 'https://luc4xz.github.io/CX-Web/']
      // },
      {
        date: 'Jun. 2026',
        content: '🎉 We are excited to welcome our new lab members: the amazing research interns Xinyi Li (UMich) and Chengran Xu (UW–Madison)!!',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ['https://adelinexinyi.github.io/', 'https://luc4xz.github.io/CX-Web/']
      },
      {
        date: 'Jun. 2026',
        content: 'I have attended NetSci 2026 at Boston and presented two working papers!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ['https://www.netsci2026.com/'],
        img: [],
        location: 'Boston, MA, USA',
      },
      {
        date: 'Jun. 2026',
        content: 'Glad to be invited as the PC member in VIS x GenAI workshop & VIS Art Program (VISAP) at VIS 2026!',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ['https://visxgenai.github.io/#program', 'https://visap.net/2026/']
      },
      // {
      //   date: 'May 2026',
      //   content: '💼 I visited Fumeng (UMD) and Zhicong (GMU) in the DC area! It was wonderful catching up with friends in the VIS/HCI community!',
      //   category: [newsCategory.ALL, newsCategory.IN2026],
      // },
      {
        date: 'May 2026',
        content: '💼 I attended the NSF APTO Convening 2026 in Washington, D.C. and had a wonderful reunion with the CSSI old friends!',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ['https://northwestern-cssi.github.io/APTOConvening2026/']
      },
      {
        date: 'Apr. 2026',
        content: '🎉 One of my working paper has been accepted by the ICSSI 2026 conference! See you in June at Boulder, Colorado!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ['https://icssi.org/'],
      },
      {
        date: 'Apr. 2026',
        content: '🎉 Two of our working papers are accepted by the IC2S2 conference! See you in July at Burlington, Vermont!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ['https://ic2s2-2026.org/'],
        img: [],
        location: 'Burlington, Vermont, USA',
      },
      {
        date: 'Apr. 2026',
        isNew: true,
        content: '👀 Our latest working paper, "Figures as Interfaces: Toward LLM-Native Artifacts for Scientific Discovery," is now available on arXiv! Over the past two years, we\'ve been exploring new paradigms for scientific discovery in the age of generative AI, and this work marks a new milestone toward rethinking figures as a new type of artifact for discovery! Check our paper and fantastic demo video for more details!',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ['https://llm-native-figure.com/', 'https://arxiv.org/abs/2604.08491'],
        img: [LLMNativeFigureUrl],
        location: 'Online',
      },
      {
        date: 'Mar. 2026',
        content: '🎨 Our paper SciSciGPT has been selected as the Journal Cover of Nature Computational Science! Amazing work done by our artist Hanna Renedo! Explore our design idea with the link attached!',
        category: [newsCategory.ALL, newsCategory.AWARDS, newsCategory.IN2026],
        link: ['https://www.nature.com/natcomputsci/volumes/6/issues/3'],
        img: [NatureSciSciGPTCoverUrl],
        location: 'Online',
      },
      {
        date: 'Mar. 2026',
        content: '🏆 Our paper "Interaction-Augmented Instruction: Modeling the Synergy of Prompts and Interactions in Human-GenAI Collaboration" has won the CHI 2026 Honourable Mention Award!',
        category: [newsCategory.ALL, newsCategory.AWARDS, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ['https://arxiv.org/abs/2510.26069'],
        img: [],
        location: 'Barcelona, Spain',
      },
      {
        date: 'Mar. 2026',
        content: '🎉 Three of our research papers have been covered by the Northwestern Innovation Institute (NI Institute): "Can AI find hidden innovators?"',
        link: ['https://www.niinstitute.org/press/finding-the-innovators-hiding-in-plain-sight?mc_cid=3fc220dd89&mc_eid=1e802df9a1', 'https://www.niinstitute.org/press/new-platform-tracks-the-real-world-impact-of-research-funding?mc_cid=3fc220dd89&mc_eid=1e802df9a1', 'https://www.niinstitute.org/?mc_cid=3fc220dd89&mc_eid=1e802df9a1'],
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        img: [],
        location: 'Kellogg School of Management, Northwestern University, USA',
      },
      {
        date: 'Mar. 2026',
        content: '🎉 Our reflection on the future of AI agents for scientific discovery, drawn from building SciSciGPT, is now published in the Nature journal!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ['https://www.nature.com/articles/d41586-026-00665-y'],
        img: [NatureCommentSciSciGPT],
        location: 'Online',
      },
      {
        date: 'Feb. 2026',
        content: '🎉 Our position paper "Situated and Dynamic Human-AI Communication through Generative Interaction-Augmented Instruction at Runtime" has been accepted by CHI 2026 Workshop on "What does Generative UI mean for HCI Practice?"! More details to come later.',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: [],
        img: [],
        location: 'Barcelona, Spain',
      },
      {
        date: 'Feb. 2026',
        content: '👥 I\'m invited to serve as a member of the ACM Multimedia 2026 Program Committee!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ["https://2026.acmmm.org/"],
        img: [],
        location: '',
      },
      {
        date: 'Feb. 2026',
        content: '🎉 Three of our papers are invited to be presented at the NetSci 2026 conference! See you in June in Boston!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ["https://www.netsci2026.com/"],
        img: [],
        location: 'Boston, USA',
      },
      {
        date: 'Feb. 2026',
        content: '💵 I’ve been awarded the First-Year Assistant Professor (FYAP) Grant from the Council on Research and Creativity at Florida State University!',
        category: [newsCategory.ALL, newsCategory.IN2026, newsCategory.AWARDS],
        link: ["https://internalfunding.research.fsu.edu/programs/fyap/"],
        img: []
      },
      {
        date: 'Feb. 2026',
        content: '👥 I\'m invited to serve as a member of the IEEE VIS 2026 Papers Program Committee!',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2026],
        link: ["https://ieeevis.org/year/2026/welcome/"],
        img: [],
        location: '',
      },
      {
        date: 'Feb. 2026',
        content: '🎉 Our paper, "DietGlance: Dietary Monitoring and Personalized Analysis at a Glance with Knowledge-Empowered AI Assistant," has been accepted for publication in ACM Transactions on Computing for Healthcare!',
        category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2026],
        link: [DietGlancePDFUrl],
        img: []
      },
      {
        date: 'Jan. 2026',
        content: '👏 Welcome Jason, Tony, and Yusong join our lab as research assistants!',
        // location: 'Online',
        category: [newsCategory.ALL, newsCategory.IN2026],
        link: ["https://jiachenjasonzhong.github.io/jiachen_homepage/", "https://yusongggg17.github.io/Personal-Website/", "https://tonyguo30.github.io/TonyGuo.github.io/"],
        img: []
      },
      {
        date: 'Jan. 2026',
        content: '📚 Our latest working paper, a survey about AI for Science, is online avalible: "A Survey of Human-AI Collaboration for Scientific Discovery"!',
        // location: 'Online',
        category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2026],
        link: [SurveyHAIPDFUrl],
        img: []
      },
      {
        date: 'Jan. 2026',
        content: '🎉 Our paper "Interaction-Augmented Instruction: Modeling the Synergy of Prompts and Interactions in Human-GenAI Collaboration" has been accepted by CHI 2026!',
        location: 'Barcelona, Spain',
        category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2026],
        link: ['https://arxiv.org/abs/2510.26069'],
        img: []
      },
      {
        date: 'Jan. 2026',
        content: '🎉 Our paper "DAVA: Decoding Art with Visual Analytics through Feature Modeling and Multi-Agent Collaboration" has been accepted by IEEE TVCG!',
        location: 'Boston, USA',
        category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2026],
        link: ['https://www.computer.org/csdl/journal/tg/5555/01/11354149/2dkoRN33nig'],
        img: []
      },
      {
        date: 'Dec. 2025',
        content: '🎉 Our paper SciSciGPT is officially published online at Nature Computational Science: https://www.nature.com/articles/s43588-025-00906-6',
        // location: 'Online',
        category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2025],
        link: ['https://www.nature.com/articles/s43588-025-00906-6'],
        img: []
      },
      {
        date: 'Nov. 2025',
        content: '👥 Honored to be invited as a program committee member for AI4SciSci 2025 (The 2nd International Workshop on Artificial Intelligence for the Science of Science)!',
        // location: 'Online',
        category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2025],
        link: ['https://ai4scisci.github.io/2025/'],
        img: []
      },
        {
            date: 'Nov. 2025',
            content: '🎉 Our latest paper: "EMINDS: Understanding User Behavior Progression for Mental Health Exploration on Social Media" has been accepted by IEEE TVCG!',
            // location: 'Online',
            category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2025],
            link: [EMINDSPDFUrl],
            img: []
        },
        {
          date: 'Nov. 2025',
          content: '📚 Our latest working paper -- a survey about human-genAI collaboration is online avalible: "Interaction-Augmented Instruction: Modeling the Synergy of Prompts and Interactions in Human-GenAI Collaboration"',
          location: 'arXiv',
          category: [newsCategory.ALL, newsCategory.PUBLICATION, newsCategory.IN2025],
          link: ['https://arxiv.org/abs/2510.26069'],
          // img: []
      },
        {
          date: 'Oct. 2025',
          content: '📷 Our latest working paper has been covered by the Nature news: "Will your study change the world? This AI tool predicts the impact of your research"',
          // location: 'Online, USA',
          category: [newsCategory.ALL, newsCategory.MEDIA, newsCategory.IN2025],
          link: ['https://www.nature.com/articles/d41586-025-03120-6', 'https://arxiv.org/abs/2509.16323'],
          img: [NatureNewsFtFUrl]
        },
        {
            date: 'Oct. 2025',
            content: '🎉 Our latest paper: "SciSciGPT: Advancing Human-AI Collaboration in the Science of Science" has been accepted by Nature Computational Science! Please check our preprint on arXiv for more details! ',
            // location: 'Online, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2025
            ],
            link: [
                'https://www.nature.com/articles/s43588-025-00906-6', 'https://sciscigpt.ngrok.app/'
            ],
            img: [ncsLogo]
        },
        {
            date: 'Oct. 2025',
            content: '🎉 Our paper SciSciGPT is accepted to be presented at the Innovation Information Initiative Technical Working Group Meeting, Fall 2025! See you in December in Boston!',
            location: 'Boston, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2025
            ],
            link: ['https://www.nber.org/conferences/innovation-information-initiative-technical-working-group-meeting-fall-2025'],
            img: [nberLogo]
        },
        {
            date: 'Aug. 2025',
            content: '✈️ I joined the Department of Computer Science at the Florida State University as a tenure-track Assistant Professor!',
            location: 'Tallahassee, USA',
            category: [
                newsCategory.ALL, newsCategory.IN2025
            ],
            link: ['https://www.fsu.edu/cs/'],
            img: []
        },
        {
            date: 'Jun. 2025',
            content: '🧑🏻‍🎨 I will present our latest working paper at the Data | Art 2025 Symposium in Harvard University!',
            location: 'Boston, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2025
            ],
            link: ['https://data-art.info/'],
            img: []
        }, {
            date: 'Feb. 2025',
            content: '🎉  Our paper "Prompting Generative AI with Interaction-Augmented Instructions" has been accepted by CHI 2025, Late-Breaking Work (LBW)!',
            location: 'Yokohama, Japan',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2025
            ],
            link: ['https://chi2025.acm.org/for-authors/late-breaking-work/'],
            img: []
        }, {
            date: 'Feb. 2025',
            content: '💼 I was invited to give a research talk at Social Computing Group at Microsoft Research Asia (MSRA). Many thanks to Haotian Li for the invitation!',
            location: 'Online',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2025
            ],
            link: [
                'https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/', 'https://www.microsoft.com/en-us/research/people/xingx/', 'https://haotian-li.com/'
            ],
            img: []
        }, {
            date: 'Jan. 2025',
            content: '🎉 Two of our papers are accepted by ISEA2025: "Behind the Molecules: An Alternative Data Visualization to Critic Chemical Abuse in Food Production" and "Hidden Incidents of Animal Euthanasia: Exploring Kinship under Dominance and Affection".',
            location: 'South Korea',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2025
            ],
            link: ['https://isea2025.isea-international.org/about/theme/'],
            img: []
        }, {
            date: 'Dec. 2024',
            content: '🎉 Our paper "InclusiViz: Visual Analytics of Human Mobility Data for Understanding and Mitigating Urban Segregation" has been accepted by PacificVis 2025 (TVCG Journal Track)!',
            location: 'Taipei, Taiwan',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://pacificvis2025.github.io/pages/index.html'],
            img: []
        }, {
            date: 'Oct. 2024',
            content: '🧑🏻‍🎨 We will be holding an art exihibition titled "Altering Nature: Exploring Life in Computational Art". Exhibition Opening: Oct. 30th, 2024 @15:00-17:00 (CST). Welcome to join us!',
            location: '@Ping Yuan Andkinmay W Tang Gallery, HKUST, Hong Kong.',
            category: [
                newsCategory.ALL, newsCategory.IN2024
            ],
            link: [
                'https://ais.hkust.edu.hk/whats-happening/events/altering-nature-exploring-life-computational-art', 'https://library.hkust.edu.hk/exhibitions/computational-art/', 'https://entrepreneurs.hk/content/2024/10/19/altering-nature-exploring-life-in-computational-art-a-new-era-of-arttech-and-curation/'
            ],
            img: [computationalArtExhibitionUrl]
        }, {
            date: 'Sept. 2024',
            content: <span>💬 I interviewed Amy Cesal, one of the co-founders from
                <a href="https://www.datavisualizationsociety.org/">Data Visualization Society (DVS)</a>, and Daria Koshkina, a data visualization research specialist from
                <a href="https://barabasilab.com/">The BarabasiLab</a>, as our special guests for our VISAP 2024 panel "What Do Visualization Art Projects Bring to the VIS Community?" Welcome to join us on Wednesday, Oct 16th, 2024 @07:30–08:45am (EDT)
            </span>,
            location: 'Online',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: ['https://ieeevis.org/year/2024/program/session_panel1.html'],
            img: []
        }, {
            date: 'July. 2024',
            content: '🎉 Our paper "InclusiViz: Visual Analytics of Human Mobility Data for Understanding and Mitigating Urban Segregation" has been accepted as a poster for ChinaVis 2024! ',
            location: 'Hong Kong, China',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: [InclusionVizPaperUrl],
            img: []
        }, {
            date: 'July. 2024',
            content: '🎉 Our submission "What Do Visualization Art Projects Bring to the VIS Community?" has been accepted as a panel for VIS 2024! More details come later. Looking forward to meeting you in Florida!',
            location: 'Florida, USA',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: ['https://shuxinhuan.github.io/visap-panel/'],
            img: []
        }, {
            date: 'July. 2024',
            content: '💼 I was invited to give a research talk entitled "Visualization and Data Intelligence in the Era of Digital Humanities: Case Studies in Quantitative History and Aesthetic Appreciation" @Peking University, 2024 PKU International Visualization Summer School. Many thanks to Prof. Xiaoru Yuan for the invitation!',
            location: 'Online, China',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: ['https://chinavis.org/s24/index_en.html'],
            img: []
        }, {
            date: 'July. 2024',
            content: '🗣 I attended the IC2S2 (International Conference on Computational Social Science) conference and present our paper InnovationInsights.',
            location: 'Philadelphia, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://ic2s2-2024.org/'],
            img: []
        }, {
            date: 'July. 2024',
            content: '🗣 I attended the ICSSI (International Conference on the Science of Science & Innovation) conference and present a working paper.',
            location: 'National Academy of Sciences, DC, USA',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: ['https://www.icssi.org/2024-schedule'],
            img: []
        }, {
            date: 'May. 2024',
            content: '💼 I was invited to give a research talk entitled "Visual Data Intelligence for Quantitative History and Aesthetic Appreciation in the Age of Digital Humanities" to The School of Art and Archaaeology @Zhejiang University. Many thanks to Prof. Tan Tang for the invitation!',
            location: 'Online, China',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: ['http://www.soaa.zju.edu.cn/main.htm'],
            img: []
        }, {
            date: 'Apr. 2024',
            content: '🧑🏻‍🎨 One of our artwork has been accepted by SIGGRAPH 2024 Art Gallery!! More details come later. Looking forward to meeting you in Denver, Colorado!',
            location: 'Denver, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://s2024.siggraph.org/exhibit-at-siggraph/'],
            img: []
        }, {
            date: 'Apr. 2024',
            content: '💼 I was invited to give a research talk entitled "Data-Driven Human-Machine Intelligence for Human and Social Dynamics" to The MU Collective Group (directed by Jessica Hullman and Matthew Kay) @Northwestern University. Many thanks to Fumeng Yang and Ziyang Guo for the invitation!',
            location: 'Evanston, USA',
            category: [
                newsCategory.ALL, newsCategory.TALK, newsCategory.IN2024
            ],
            link: ['https://mucollective.northwestern.edu/'],
            img: []
        }, {
            date: 'Apr. 2024',
            content: '🗣 One of our paper has been invited to a contributed talk @IC2S2 (International Conference on Computational Social Science) in July! More details come later.',
            location: 'Philadelphia, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://ic2s2-2024.org/'],
            img: []
        }, {
            date: 'Apr. 2024',
            content: '🗣 One of our paper has been invited to a contributed talk @ICSSI (International Conference on the Science of Science & Innovation) in July! More details come later.',
            location: 'National Academy of Sciences, USA',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://www.icssi.org/2024-schedule'],
            img: []
        }, {
            date: 'Feb. 2024',
            content: '🧑🏻‍🎨 Our paper "Hidden Incidents of Pet Food: Portraying Taurine Deficiency in Cats" is accepted by ISEA2024 (the top conference in media art)!',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://isea2024.isea-international.org/welcome/'],
            img: [ISEA2024Logo]
        }, {
            date: 'Jan. 2024',
            content: '🎉 Our paper "A Comparative Study on Fixed-order Event Sequence Visualizations: Gantt, Extended Gantt, and Stringline Charts" is accepted by IEEE TVCG!',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2024
            ],
            link: ['https://osf.io/qdpzm/']
        }, {
            date: 'Nov. 2023',
            content: '🧑🏻‍🎨 Our data artwork "Posts with no Response: The Island of Loneliness" has been exihibited at Information+ Conference 2023!',
            location: 'Edinburgh',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: ['https://informationplusconference.com/2023/#exhibition'],
            img: [InfoPlus23]
        }, {
            date: 'Oct. 2023',
            content: '🗣 Our paper "InnovationInsights: A Visual Analytics Approach for Understanding the Dual Frontiers of Science and Technology" has been presented at IEEE VIS2023!',
            location: 'Melbourne',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: ['https://kellogg-cssi.github.io/InnovationInsights/'],
            img: [VIS23InnovationInsightsA, VIS23InnovationInsightsB]
        }, {
            date: 'Oct. 2023',
            content: '🧑🏻‍🎨 Our data artwork "Posts with no Response: The Island of Loneliness" has been exihibited @VISAP2023 at IEEE VIS2023!',
            location: 'Melbourne',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: ['https://visap.net/2023/'],
            img: [VISAP23A, VISAP23B]
        }, {
            date: 'Oct. 2023',
            content: '🧑🏻‍🎨 Our "China in Maps" project with HKUST Library is finally coming to life with an exhibition opening ceremony at HKUST!',
            location: 'Hong Kong',
            category: [
                newsCategory.ALL, newsCategory.MEDIA, newsCategory.IN2023
            ],
            link: ['https://library.hkust.edu.hk/china-in-maps/'],
            img: [chinainmaps]
        }, {
            date: 'Sept. 2023',
            content: '🧑🏻‍🎨 Three of our data-driven artworks have been longlisted by 2023 IIB Awards (Information is Beautiful Awards)!!!',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.AWARDS, newsCategory.IN2023
            ],
            link: [
                'https://www.informationisbeautifulawards.com/showcase/6355-posts-with-no-response-the-island-of-loneliness', 'https://www.informationisbeautifulawards.com/showcase/6609-hidden-incidents-of-pet-food-melamine-adulteration', 'https://www.informationisbeautifulawards.com/showcase/6614-hidden-incidents-of-pet-food-pentobarbital-secondary-poisoning',
            ],
            img: [IIBLogo]
        }, {
            date: 'Aug. 2023',
            content: '🏆 Our paper "InnovationInsights: A Visual Analytics Approach for Understanding the Dual Frontiers of Science and Technology" has won Best Paper Honorable Mentions @IEEE VIS2023!!!',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.AWARDS, newsCategory.IN2023
            ],
            link: ['https://ieeevis.org/year/2023/info/awards/best-paper-awards']
        }, {
            date: 'Aug. 2023',
            content: '🎉 Our paper "NeighViz: Towards Better Understanding of Neighborhood Effects on Social Groups with Spatial Data" has been accepted by VDS2023@IEEE VIS!! More details to come later.',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: ['https://www.visualdatascience.org/2023/']
        }, {
            date: 'Jul.-Aug. 2023',
            content: '🧑🏻‍🎨 Our data art paper "Posts with no Response: The Island of Loneliness" has been accepted by VISAP2023 (both Pictorial and Artwork tracks) and Information+ conference! Cannot wait to meet all friends in Melbourne and Edinburgh!',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: [LonelyIslandVideoUrl]
        }, {
            date: 'Jun. 2023',
            content: '🎉 Two of our papers have been accepted by the VIS2023 conference! Cannot wait to meet all friends in Melbourne!',
            location: '',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: ['https://ieeevis.org/year/2023/welcome']
        }, {
            date: 'Jun. 2023',
            content: '🎉 Our paper "InnovationInsights: A Visual Analytics Approach for Understanding the Dual Frontiers of Science and Technology" has been accepted as a poster and been presented at the ICSSI2023 conference!',
            location: 'Evanston',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.IN2023
            ],
            link: ['https://www.icssi.org/2023-schedule']
        }, {
            date: 'Nov. 2022',
            content: '🧑🏻‍🎨 Our data art work was reported by The Paper’s art column, one of the mainstream media in China: "Please, stop cramming the text so densely"',
            location: 'Online',
            category: [
                newsCategory.ALL, newsCategory.MEDIA, newsCategory.BEFORE2023
            ],
            link: ['https://mp.weixin.qq.com/s/3GJ11TLT9YALqaJ9hQ5TmA']
        }, {
            date: 'Jan. 2022',
            content: '🧑🏻‍🎨 Our data art work was reported by a design and innovation WeChat Official Account: "Adding some design to data: the many possibilities of data visualization"',
            location: 'Online',
            category: [
                newsCategory.ALL, newsCategory.MEDIA, newsCategory.BEFORE2023
            ],
            link: ['https://mp.weixin.qq.com/s/-sbNslBgCN5hHGnStHAhHQ']
        }, {
            date: 'Oct. 2022',
            content: 'I attended VIS 2022 (The IEEE Visualization Conference) in Oklahoma! This is the first time I attended an onsite conference!',
            location: 'Virtual',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.TALK, newsCategory.BEFORE2023]
        }, {
            date: 'Oct. 2022',
            content: '🧑🏻‍🎨 Our data-driven art work "Explore Mindfulness without Deflection: A Data Art Based on the Book of Songs" has been longlisted in Information is Beautiful Award 2022!',
            location: 'Evanston',
            category: [
                newsCategory.ALL, newsCategory.BEFORE2023
            ],
            link: ['https://www.informationisbeautifulawards.com/showcase/5762-explore-mindfulness-without-deflection-a-data-art-based-on-the-book-of-songs'],
            img: [IIBLogo]
        }, {
            date: 'Sept. 2022',
            content: '🛫 I joined CSSI Lab at Northwestern University!',
            location: 'Evanston',
            category: [
                newsCategory.ALL, newsCategory.BEFORE2023
            ],
            img: [cssiLogo]
        }, {
            date: 'Aug. 2022',
            content: '🎓 I graduated from HKUST as a CSE PhD!',
            location: 'Hong Kong',
            category: [newsCategory.ALL, newsCategory.BEFORE2023]
        }, {
            date: 'Aug. 2022',
            content: '🧑🏻‍🎨 Our data-driven art work "Hidden Incident of Pet Food" has been exhibiteed on the 1st CMA International Symposium and Exhibition!',
            location: 'Hong Kong',
            category: [
                newsCategory.ALL, newsCategory.BEFORE2023
            ],
            link: ['https://electricdreams.ust.hk/hidden-incident-of-pet-food/']
        }, {
            date: 'Aug. 2022',
            content: '🧑🏻‍🎨 Our data-driven art work "Explore Mindfulness without Deflection: A Data Art Based on the Book of Songs" has been exhibiteed on the 1st CMA International Symposium and Exhibition!',
            location: 'Hong Kong',
            category: [
                newsCategory.ALL, newsCategory.BEFORE2023
            ],
            link: ['https://electricdreams.ust.hk/explore-mindfulness-without-deflection-a-data-art-based-on-the-book-of-songs/']
        }, {
            date: 'Jun. 2022',
            content: '🏆 I won HKUST RedBird Academic Excellence Award!',
            location: 'Hong Kong',
            category: [newsCategory.ALL, newsCategory.AWARDS, newsCategory.BEFORE2023]
        }, {
            date: 'Jun. 2022',
            content: '🗣 I was invited to ACM SIGGRAPH SPARKS, a project of the DIGITAL ARTS COMMUNITY (DAC), ACM SIGGRAPH, and presented our data art work about the Book of Songs',
            location: 'Virtual',
            category: [
                newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.TALK, newsCategory.BEFORE2023
            ],
            link: ['https://dac.siggraph.org/sparks-jun2022/'],
            img: [sparksImg]
        }, {
            date: 'Oct. 2021',
            content: '🗣 I attended VISAP2021 @VIS 2021 (The IEEE Visualization Conference), presented 1 art paper',
            location: 'Virtual',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.TALK, newsCategory.BEFORE2023]
        }, {
            date: 'Oct. 2021',
            content: '🗣 I attended VIS 2021 (The IEEE Visualization Conference), presented 2 full papers',
            location: 'Virtual',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.TALK, newsCategory.BEFORE2023]
        }, {
            date: 'May 2021',
            content: '🗣 I visited FDUVIS, and presented my research about CareerLens',
            location: 'Sahnghai, China',
            category: [newsCategory.ALL, newsCategory.VISITS, newsCategory.TALK, newsCategory.BEFORE2023]
        }, {
            date: 'Apr. 2021',
            content: '🗣 I was invited by CVM 2021 (The International Conference on Computational Visual Media), and presented my research about CareerLens',
            location: 'Qingdao, China',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.TALK, newsCategory.BEFORE2023]
        }, {
            date: 'Aug. 2020',
            content: 'ChinaVIS 2020 (China Visualization and Visual Analytics Conference)',
            location: 'Xi-an, China',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.BEFORE2023]
        }, {
            date: 'Aug. 2019',
            content: 'CIPS-SMP (Social Media Processing Conference)',
            location: 'Shenzhen, China',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.BEFORE2023]
        }, {
            date: 'Oct. 2017',
            content: '🏆 I won He Zhijun Scholarship in College of Computer Science and Technology (top 10) @ Zhejiang University',
            location: 'Hangzhou, China',
            category: [newsCategory.ALL, newsCategory.AWARDS, newsCategory.BEFORE2023]
        }, {
            date: 'Oct. 2017',
            content: '🏆 I went to CNCC (China National Computer Congress) and was awarded as The CCF (China Computer Federation) Elite Collegiate Award(2017)',
            location: 'Fuzhou, China',
            category: [newsCategory.ALL, newsCategory.CONFERENCE, newsCategory.AWARDS, newsCategory.BEFORE2023]
        },
    ],
    labMemberPage: {
        currentMembers: [
            {
                name: 'Yifang Wang',
                position: 'Principle Investigator',
                homepageUrl: 'https://wangyifang.top/',
                img: yifangImg,
                // specialty: 'Data Visualization',
                // institution: 'Florida State University',
            },
            // hidden for now: Qinshi Zhang (uncomment to show again)
            // {
            //     name: 'Qinshi Zhang',
            //     position: 'PhD Student',
            //     institution: 'Florida State University',
            //     homepageUrl: 'https://carolzhangzz.github.io/',
            //     img: qinshiImg,
            //     specialty: 'HAI for Science, AI Agent, Human-AI Collaboration'
            // },
            {
                name: 'Hongxin Fu',
                position: 'PhD Student',
                institution: 'Florida State University',
                homepageUrl: 'https://april-fu.com/',
                img: hongxinImg,
                specialty: 'AI Agent, Data Visualization, AI for Science'
            },
            {
                name: 'Ziqing Qian',
                position: 'Visiting Researcher',
                institution: 'Tongji University',
                homepageUrl: 'https://ziqingqian.github.io',
                img: ziqingImg,
                specialty: 'AI for Science, AI Agent, Complex Network, Complex System'
            },
            {
                name: 'Shuo Yan',
                position: 'Visiting Researcher',
                institution: 'East China Normal University',
                homepageUrl: 'https://yanmouren-27.github.io/',
                img: shuoImg,
                specialty: 'Data Visualization, Visual Analytics, Human-Computer Interaction'
            },
            {
              name: 'Haoze (Tony) Guo',
              position: 'Visiting Researcher',
              institution: 'University of Wisconsin–Madison (undergraduate)',
              homepageUrl: 'https://tonyguo30.github.io/TonyGuo.github.io/',
              img: tonyImg,
              specialty: 'Human-Computer Interaction, Generative UI, Computational Social Science'
            },
        ],
        // `now`: where they went next (shown on the WHALES Lab page)
        formerCollaboratedStudents: [
            {
                name: 'Junxiu Tang',
                role: 'Postdoctoral fellow',
                university: 'Northwestern University',
                homepageUrl: 'https://ahugh19.github.io/',
                field: 'Data-Driven Art, Visual Analytics, Data-Driven Communication',
                now: 'Northwestern University',
            },
            {
                name: 'Rui Sheng',
                role: 'Ph.D. student',
                university: 'Hong Kong University of Science and Technology',
                homepageUrl: 'https://dylansheng.github.io/',
                field: 'Data Visualization, Human-AI Collaboration, Healthcare',
                now: 'Northeastern University',
            },
            {
                name: 'Leixian Shen',
                role: "Ph.D. student",
                university: 'Hong Kong University of Science and Technology',
                homepageUrl: 'https://shenleixian.github.io/',
                // img: leixianImg,
                field: 'Human-GenAI Collaboration, Data Storytelling, Visual Data Analysis',
                "year": "2024-2026",
                now: 'Microsoft Research Asia (MSRA)',
            },
            {
                "year": "2024-2025",
                "name": "Erzhuo Shao",
                "role": "Ph.D. student",
                "field": "Industrial Engineering & Management Sciences",
                "university": "Northwestern University"
            },
            {
                "year": "2023-2026",
                "name": "Zhihan Jiang",
                "homepageUrl": 'https://zhihanjiang.com/',
                "role": "Ph.D. student",
                "field": "Public Health, Multimodal Analytics, Wearable Sensing",
                "university": "The University of Hong Kong",
                now: 'Columbia University',
            },
            {
                "year": "2024-2025",
                "name": "Zelin Li",
                "role": "Master student",
                "field": "Computer Science",
                "university": "Northwestern University"
            },
            {
                "year": "2024-2025",
                "name": "Siren Wang",
                "role": "Master student",
                "field": "Computer Science",
                "university": "Northwestern University"
            },
            {
                "year": "2024",
                "name": "Yoonsung Jeong",
                "role": "Master student",
                "field": "Computer Science",
                "university": "Northwestern University"
            }, {
                "year": "2024",
                "name": "Keyi Wang",
                "role": "Master student",
                "field": "Computer Science",
                "university": "Northwestern University"
            },

            // {"year": "2024-2025", "name": "Leixian Shen", "role": "Ph.D. student", "field": "Computer Science", "university": "The Hong Kong University of Science and Technology"},
            // {"year": "2022-2025", "name": "Rui Sheng", "role": "Ph.D. student", "field": "Computer Science", "university": "The Hong Kong University of Science and Technology"},
            {
                "year": "2021-2025",
                "name": "Yue Yu",
                "role": "MPhil student",
                "field": "Computer Science and Humanities",
                "university": "The Hong Kong University of Science and Technology",
                now: 'Ph.D. student, HKUST VisLab',
            }, {
                "year": "2022-2025",
                "name": "Ziwei Wu",
                "role": "Ph.D. student",
                "field": "Computational Media and Arts",
                "university": "The Hong Kong University of Science and Technology"
            }, {
                "year": "2024-2025",
                "name": "Hanlu Ma",
                "role": "Ph.D. student",
                "field": "Computational Media and Arts",
                "university": "The Hong Kong University of Science and Technology"
            }, {
                "year": "2020-2021",
                "name": "Yifan Cao",
                "role": "Ph.D. student",
                "field": "Computational Media and Arts",
                "university": "The Hong Kong University of Science and Technology"
            },

            // {"year": "2022-2025", "name": "Zhihan Jiang", "role": "Ph.D. student", "field": "Electrical and Electronic Engineering", "university": "The University of Hong Kong"},

            {
                "year": "2022-2024",
                "name": "Xiaoyu Qi",
                "role": "MPhil student",
                "field": "Computer Science",
                "university": "Tongji University"
            },
            // {"year": "2024-2025", "name": "Xiaoyan Gu", "role": "Ph.D. student", "field": "Computer Science", "university": "Zhejiang University"},
            {
                "year": "2022-2025",
                "name": "Wei Zhang",
                "role": "Ph.D. student",
                "field": "Computer Science",
                "university": "Zhejiang University"
            },
            // {"year": "2022-2025", "name": "Junxiu Tang", "role": "Ph.D. student", "field": "Computer Science", "university": "Zhejiang University"},
            {
                "year": "2023-2024",
                "name": "Jiayi Zhou",
                "role": "UG student",
                "field": "Industrial Design",
                "university": "Zhejiang University"
            }, {
                "year": "2022-2023",
                "name": "Qisen Yang",
                "role": "UG student",
                "field": "Computer Science",
                "university": "Zhejiang University"
            }, {
                "year": "2021-2022",
                "name": "Duruo Li",
                "role": "UG student",
                "field": "Statistics",
                "university": "Zhejiang University"
            }, {
                "year": "2020-2021",
                "name": "Huihua Lu",
                "role": "MPhil student",
                "field": "Computer Science",
                "university": "Zhejiang University"
            }, {
                "year": "2020-2021",
                "name": "Haoren Wang",
                "role": "UG student",
                "field": "Geographical Information Science",
                "university": "Zhejiang University"
            },
        ],
        // the lab's cats (Hongxin's), listed after everyone else on the WHALES Lab page
        labCats: [
            { name: 'Chestnut', position: 'Senior Reviewer', institution: '10 years old', img: catChestnutImg },
            { name: 'Egg Tart', position: 'Chief Nap Officer', institution: '8 years old', img: catEggTartImg },
        ],
        collaborators: [
            // {
            // name: 'Haotian Li',
            // position: 'Research Scientist',
            // homepageUrl: 'https://haotian-li.com/',
            // img: haotianImg,
            // specialty: 'Human-AI Collaboration, Generative AI, Data Storytelling',
            // institution: 'Microsoft Research Asia',
            // },
            // {
            // name: 'Wei Zhang',
            // position: 'Assistant Professor',
            // institution: 'Zhejiang University',
            // homepageUrl: 'https://zwstart.github.io/',
            // img: weiZhangImg,
            // specialty: 'Digital Humanities, Image Analysis, LLM',
            // },
            {
                name: 'Xiaoyan Gu',
                position: 'Visiting Researcher',
                institution: 'Zhejiang University',
                homepageUrl: '',
                img: xiaoyanImg,
                specialty: 'Multimodal Analytics, LLM, Digital Humanities'
            },
            {
                name: 'Haozhong Liu',
                position: 'Visiting Researcher',
                institution: 'Zhejiang University & UIUC (Undergraduate in Computer Engineering)',
                homepageUrl: 'https://haozhongliu.github.io/',
                img: haozhongImg,
                specialty: 'Human-Computer Interaction, Human-Agent Collaboration, AI-mediated Decision-Making, Visualization'
            },
        ],
        // display order of the members on the WHALES Lab page (anyone not listed goes last)
        memberOrder: [
            'Hongxin Fu', /* 'Qinshi Zhang', */ 'Haoze (Tony) Guo', 'Chengran Xu', 'Haozhong Liu',
            'Xiaoyan Gu', 'Ziqing Qian', 'Shuo Yan', 'Xinyi Li', 'Lian Lian', 'Yusong Liang',
        ],
        internMembers: [
            {
                name: 'Chengran Xu',
                position: 'Visiting Researcher',
                institution: 'University of Wisconsin-Madison (Undergraduate in Computer Science and Information Science)',
                homepageUrl: 'https://luc4xz.github.io/CX-Web/',
                img: chengranImg,
                specialty: 'Human-AI Interaction, Industrial Design'
            },
            {
                name: 'Xinyi Li',
                position: 'Research Intern',
                institution: 'University of Michigan (B.S. in Computer Science)',
                homepageUrl: 'https://adelinexinyi.github.io/',
                img: xinyiImg,
                specialty: 'Human-Computer Interaction and Multi-Agent Systems'
            },
            {
                name: 'Lian Lian',
                position: 'Research Intern',
                institution: 'Washington University in St. Louis (M.S. in Computer Science)',
                homepageUrl: 'https://lianlian242.github.io/my-homepage/',
                img: undefined,
                specialty: 'Multimodal Fusion Modeling, LLM Finetuning'
            },
            // {
            //     name: 'Jiachen (Jason) Zhong',
            //     position: 'Research Assistant',
            //     institution: 'OxeFit, Inc. (Data Scientist), University of Washington and University of Amsterdam (M.S.)',
            //     homepageUrl: 'https://jiachenjasonzhong.github.io/jiachen_homepage/',
            //     img: jiachenImg,
            //     specialty: 'LLM Multi-Agent Systems'
            // },
            {
              name: 'Yusong Liang',
              position: 'Research Intern',
              institution: 'Florida State University (Undergraduate in Computer Science)',
              homepageUrl: 'https://yusongggg17.github.io/Personal-Website/',
              img: yusongImg,
              specialty: 'Human-Computer Interaction, Virtual Reality, Mixed Reality'
            },
        ],
        nonHumanMembers: [
            {
                name: '',
                position: ''
            },
        ]
    },
    dataArtPage: [
        {
            category: [
                paperCategory.ALL, paperCategory.DR
            ],
            teaser: AIDanceTeaserUrl,
            award: [dataArtAwardCategory.NeurIPS2026],
            year: 2026,
            title: 'Effort',
            titleShort: 'Effort',
            classification: 'PHILOSOPHICAL REFLECTION',
            theme: ['digital world'],
            authorList: [
                'Junxiu Tang',
                'Hanna Renedo',
                'Yifang Wang',
                'Dashun Wang'
            ],
            venue: 'The 40th Conference on Neural Information Processing Systems',
            venueShort: 'NeurIPS2026 (Creative AI Track)',
            mediaCoverage: [],
            introduction: <div>
                <p>
                    "Effort" returns the trace of a model learning from human dance to the body. An open-source music-conditioned diffusion model is trained on a motion-capture dataset performed by twenty-seven professional dancers. During training, the changing loss and gradients leave a numerical trace. We take this trace out of the engineering background and turn it into two forms: it becomes music, and it becomes a sequence of Laban Effort words such as Float, Press, Punch, and Wring.
                </p>
                <p>
                    The music conditions the trained model and accompanies a human dancer, while the words guide her improvisation as choreographic prompts. A generated body, drawn as pale continuous lines from the model's own motion, and a living body then move within the same temporal structure, meeting the training trace through different representations.
                </p>
                <p>
                    As movement passes from bodies into data, through training, and back into bodies, the work asks how agency is distributed across dancers, data, models, and artistic interpretation. Who, or what, is making the dance happen?
                </p>
                <p>Human dance performance and improvisation by Qianni Wang.</p>
            </div>,
            story: <Tabs defaultActiveKey="1">Coming soon...</Tabs>,
            imageList: [AIDanceTeaserUrl],
            suppMaterialList: [
                {
                    name: 'PDF',
                    fileLink: AIDancePDFUrl
                }, {
                    name: 'Demo Video',
                    fileLink: AIDanceVideoUrl
                },
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    image: AIDanceTeaserUrl,
                    time: '2026',
                    title: 'Effort',
                    description: <>
                        <p className='description'>"Effort" returns the trace of a model learning from human dance to the body. The training log becomes both music and a sequence of Laban Effort words. The music conditions the trained model and accompanies a human dancer, while the words guide her improvisation as choreographic prompts. The two movements share a training trace and timeline, but take shape through different forms.</p>
                        <p className='description'>As movement passes from bodies into data, through training, and back into bodies, the work asks how agency is distributed across dancers, data, models, and artistic interpretation. Who, or what, is making the dance happen?</p>
                    </>
                },
                secondaryImageInfo: {
                    image: AIDanceTeaserUrl,
                    title: 'A Training Trace Becomes a Score',
                    description: <p className='description'>A change-point detector divides the training trace into fourteen stages. An artist-designed mapping reads the gradient norm through Weight, its volatility through Time, and the strength of the temporal trend through Space, and it gives one Laban Effort word to each stage. Much like Sol LeWitt's Wall Drawings, "Effort" separates the production of an instruction from its bodily realization.</p>
                },
                awardImageInfo: {
                    image: AIDanceTeaserUrl,
                    awardLogoList: [AIDanceNeurIPSLogoUrl]
                }
            }
        },
        {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.DR
            ],
            teaser: CatVisUrl,
            award: [
                dataArtAwardCategory.ISEA2024, dataArtAwardCategory.LumenPrize2024, dataArtAwardCategory.IIB2023
            ],
            year: '2024-2025',
            title: 'Hidden Incidents of Pet Food: Portraying Taurine Deficiency in Cats',
            titleShort: 'Hidden Incidents of Pet Food',
            classification: 'PROTEST AND CRITIQUE',
            theme: ['Alife'],
            authorList: [
                'Ziwei Wu',
                'Xiaofu Jin',
                'Danlu Fei',
                'Yifang Wang',
                'Guangda Zhu',
                'Kang Zhang'
            ],
            venue: 'The International Symposium on Electronic Art (the top conference in media art)',
            venueShort: 'ISEA2024',
            mediaCoverage: [
                {
                    name: 'Entrepreneurs.hk',
                    title: 'Altering Nature: Exploring Life in Computational Art -- A New Era of ArtTech and Curation',
                    fileLink: 'https://entrepreneurs.hk/content/2024/10/19/altering-nature-exploring-life-in-computational-art-a-new-era-of-arttech-and-curation/'
                }, {
                    name: 'Division of Emerging Interdisciplinary Areas (EMIA) and the Division of Arts and Machine Creativity (AMC) at HKUST',
                    title: 'Altering Nature: Exploring Life in Computational Art',
                    fileLink: 'https://library.hkust.edu.hk/exhibitions/computational-art/'
                }, {
                    name: 'HKUST News Express',
                    title: 'Hong Kong campus: information hub | A joint exhibition across two campuses! Exploring life in computational art',
                    fileLink: 'https://mp.weixin.qq.com/s/_EPj8wKEdIY3V7rbbDbVgw'
                }, {
                    name: 'Lumen Prize China (the official China partner of the UK Lumen Prize)',
                    title: 'Lumen Student Prize artist news: Ziwei Wu, Wa Liu, Yuqian Sun',
                    fileLink: 'https://mp.weixin.qq.com/s/k3z4jKViVgU6LWRxO0Aj8g'
                },
            ],
            introduction: <div>
                <p>
                    "Hidden Incidents of Pet Food" is a digital artwork that combines contemporary art, machine learning, and data storytelling. It aims to reveal a relatively unknown yet significant social issue, specifically the deficiency of taurine in cat food. Leveraging Artificial Intelligence, the authors generate digital portraits of 6,000 cats who died from this deficiency. Incorporating additional data from the documented history, the authors reveal the hidden incidents through visualization and data storytelling, showing the trending relationship between the boom of pet capital markets and the deaths of cats due to pet food problems. The AI-generated cat portraits and incident data go beyond the facts and could become a historical memorial for blind cats and those tragic fatalities linked to pet foods. Our computational approach reveals the questionable relationship between people and pets as controlled by capitalism.
                </p>
                {/* <p>《宠物食品中的隐藏事件》Hidden Incidents of Pet Food 是一个交互数字艺术作品，结合了当代艺术、机器学习和数据叙事。艺术家利用人工智能生成了6000只死于猫粮中牛磺酸缺乏的猫的数字肖像，通过整合历史文献中的额外数据，她通过可视化和数据叙事揭示了这些隐藏的事件，展示了宠物资本市场蓬勃发展与由于宠物食品问题导致的猫死亡之间的关系趋势。AI生成的猫的肖像和事件数据超越了事实本身，可能成为对那些受宠物食品问题影响而导致悲剧性死亡的猫的历史纪念。</p>
        <p>艺术家的计算方法揭示了资本主义控制下人与宠物之间值得反思的关系。</p> */} </div>,
            story: <div className="story">
                    <div>
                        <h4>Prologue</h4>
                        <p>Ziwei’s cat has passed away.</p>
                        <p>Upon investigation, it was likely due to a questionable additive in a certain brand of cat food. Although this additive is not legally banned, numerous cases have shown that it can cause severe health issues, even death, in cats. In a series of struggles between individuals and corporations, the weaker side always loses.</p>
                        <p>
                            <span style={
                                {borderBottom: '1px dotted #3F3F3F'}
                            }>So, we choose to speak through art.</span>
                        </p>

                        <br/>
                        <h4>The Artwork</h4>
                        <p>This piece is part of a series that explores the damage to life caused by the absence or presence of three specific chemical elements in pet food and even human food. At ISEA 2024, we are presenting the first of these elements—taurine.</p>
                        <p>In 1987, researchers from the University of California, Davis, published an article in Science that discussed the link between taurine and feline diseases. They noted that “feeding cats a taurine-deficient diet results in reduced plasma and tissue taurine concentrations, including in the retina and myocardium. Taurine deficiency lasting over six months can lead to feline central retinal degeneration (FCRD) and dilated cardiomyopathy (DCM).” They estimated that in the United States, at least 1,000 cats die each year due to a lack of taurine in pet food.</p>
                        <p>Canned pet food began mass production in the United States in 1922, and since then, it’s impossible to imagine or track the number of cats and other pets that have died due to taurine deficiency. It wasn’t until 1976 that studies began to examine the relationship between taurine and feline retinal health.</p>
                        <p>However, even with this research, there were no specific regulations on taurine levels in cat food at the time. In 1981, the National Research Council finally released its recommendations, stating that cat food should contain at least 500 ppm of taurine. Unfortunately, the taurine levels in commercial cat food were far below this recommendation. Given the late establishment of this standard, it’s estimated that between 1976 and 1981 alone, at least 6,000 cats died from taurine deficiency. Even after 1981, when these recommendations were widely publicized, questions remained about whether pet food manufacturers complied with the policy and whether violators were penalized.</p>
                        <p>Despite our desire to reach further back in time, the lack of reliable data restricts us to sample from the known period between 1976 and 1981. Based on this information, we have generated images to commemorate the innocent feline lives lost during this period.</p>

                        <p>We used AI to generate portraits of 6,000 cats. These cats all perished due to taurine deficiency in their food. Through this work, we aim to grant their lives a semblance of “eternity.” We reveal these hidden events using data storytelling, highlighting the trend between the booming pet food industry and the deaths of cats due to pet food issues.</p>

                        <br/>
                        <h4>Afterword</h4>
                        <p>As a data analyst, I have never encountered a project where data collection was so challenging. The number of incidents was far fewer than we imagined. Most events involving deaths due to pet food problems were not recorded in detail or reported; at best, we found sporadic investigative reports or news estimates. We suspect this is due partly to the lack of a well-established platform or institution to document these events. Moreover, it chills the heart to consider the helplessness of individual pet owners when facing massive corporations and economic interests—how many incidents had a chance to be exposed but were instead buried by capital? We may never know. This posed a significant obstacle to our initial intent to “create a digital art piece.” Thus, we turned to AI to generate virtual pet images and models, expanding the original data reasonably, enabling the current presentation.</p>
                        <p>This remains an ongoing project. We still hope to call more people to pay attention to and even get involved in the issue of food safety for pets and humans alike.</p>

                        <br/>
                        <p>2024, Year of the Wood Dragon – Beginning of Autumn</p>
                        <br/> {/* 没有数据，形成incident的数据需要7步。资本的博弈。几乎没有公开数据。联系法医等。整个过程十分艰难。 */} </div>
                </div>,
            imageList: CatVisImgUrlList,
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://behind-the-molecules.vercel.app/'
                }, {
                    name: 'PDF',
                    fileLink: CatVisPaperUrl
                }, {
                    name: 'Demo Video',
                    fileLink: CatVisVideoUrl
                },
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    image: CatVisImgUrlList[6],
                    time: 'Oct. 2024',
                    title: 'Hidden Incidents of Food Safety',
                    description: <>
                        <p>"Hidden Incidents of Pet Food: Portraying Taurine Deficiency in Cats" is a digital artwork that combines contemporary art, machine learning, and data storytelling. It aims to reveal a relatively unknown yet significant social issue, specifically the deficiency of taurine in cat food. Leveraging Artificial Intelligence, the authors generate digital portraits of 6,000 cats who died from this deficiency. Incorporating additional data from the documented history, the authors reveal the hidden incidents through visualization and data storytelling, showing the trending relationship between the boom of pet capital markets and the deaths of cats due to pet food problems. The AI-generated cat portraits and incident data go beyond the facts and could become a historical memorial for blind cats and those tragic fatalities linked to pet foods. Our computational approach reveals the questionable relationship between people and pets as controlled by capitalism.</p>
                        <p>"Hidden Incidents of Animal Euthanasia" is an interactive art display that represents secondary pentobarbital poisoning among multi-species. This work combines incident data, visualization and sonification, 3D AI generative techniques, and interactivity to enable the audiences to explore the kinship of human-animal interaction under euthanasia. Moreover, it delves into the intricate dynamics of dominance and affection that define our interactions with other sentient beings, offering a platform for critical engagement and reflection. This new approach reveals a thoughtful examination of the ethical dimensions and intricacies surrounding humane euthanasia practices, particularly the usage of synthetic drug as the means to do so.</p>
                    </>
                },
                secondaryImageInfo: {
                    image: CatVisImgUrlList[0],
                    title: 'Taurine Deficiency in Cat',
                    description: <p className='description'>In 1987, researchers from the University of California, Davis published an article in Science on the relationship between taurine and feline diseases, stating that “feeding taurinedeficient diets to cats results in low concentrations of taurine in plasma and tissues, including the retina and myocardium. Taurine depletion for more than six months may produce feline central retinal degeneration (FCRD) and dilated cardiomyopathy (DCM)”. They also estimated that at least 1,000 cats die each year in the United States because of insufficient taurine in pet food.</p>
                },
                awardImageInfo: {
                    image: CatVisImgUrlList[1],
                    awardLogoList: CatVisAwardLogoList
                }
            }
        },
        {
            category: [
                paperCategory.ALL, paperCategory.DR
            ],
            teaser: lossGenerationUrl,
            award: [dataArtAwardCategory.SIGGRAPHART],
            year: 2024,
            title: 'Loss of Sonnet 18',
            titleShort: 'Loss of Sonnet 18',
            classification: 'PHILOSOPHICAL REFLECTION',
            theme: ['digital world'],
            authorList: [
                'Junxiu Tang',
                'Jiayi Zhou',
                'Yifang Wang',
                'Xinhuan Shu',
                'Peiquan Xia',
                'Xiaojiao Chen',
                'Tan Tang',
                'Yingcai Wu'
            ],
            venue: 'SIGGRAPH 2024, Art Gallery',
            venueShort: 'SIGGRAPH Art 2024',
            mediaCoverage: [],
            introduction: <div>
                <p>
                    This project is an explorative digital art installation that delves into the phenomenon of generation loss - the inevitable degradation of information (e.g., words) quality through copying and propagation. It transcends the technical realm to probe how this concept applies to the transmission and transformation of words and meanings through time and technology.
                </p>
                <p>
                    It consists of a series of videos illustrating the loss of words themselves and their meaning, combined with real-time interpretation from both humans and machine. The project allows the audience to find a border of loss, beyond which, information of words might change.
                </p>

                <br/>
                <h4>Conceptual Foundation</h4>
                <p>At the heart of "Loss of Sonnet 18" lies an acknowledgment of the inherent loss in information storage and spreading, echoing through the corridors of human history and our methods of preserving and transmitting words. Although there is an inherent loss in information transfer, the thought behind information (i.e., the “word” in this project context) storage hardly changes.</p>
                <p>Depicting the everlasting beauty, regardless of any loss, Shakespeare’s Sonnet 18 serves as our inspiration, a poetic testament to the fleeting nature of beauty and the supposed immortality bestowed through verse. Yet, this project asks a poignant question: what happens when the medium of this immortality - the words themselves - undergo generational loss?</p>
                <p>We try to describe the loss of information through time and technique in an intuitive way, and invite the audience to feel both the changing and unchanging of thought behind different iterations of storage and spreading.</p>

                <br/>
                <h4>Artistic Interpretation and Process</h4>
                <p>Through a blend of traditional poetry and modern technology, we simulate the blurring and compression of text, such as the distortion experienced in social media and digital communication.</p>
                <p>In a nod to the pre-digital era, we present these texts upon images, like the visual nature of historical mediums written expression – ink on paper, prints, etchings on stone, all of which can be considered as images. This deliberate juxtaposition illuminates the transformative journey of words and meanings, guiding the audience through an experiential narrative where the known gradually morphs into the enigmatic.</p>
                <p>Through this artistic process, we invite the audiences to become witnesses to the subtle yet profound metamorphosis of language. They will observe familiar words and phrases slowly erode into realms of ambiguity and reinterpretation, and try to find a border of recognizable loss within this process.</p>

                <br/>
                <h4>Inspirations and Technical Aspects</h4>
                <p>Drawing from the pioneering works of Ellie Pritts (project Loss), David Elliott (JPEG compression for 600 times), Alvin Lucier (I'm Sitting in a Room), and Dietmar Offenhuber (Autographic Visualization), "Loss of Sonnet 18" represents a synthesis of art, data, and technology. Specifically, we focus on the generation loss of text data through image medium. We choose the last sentence of Shakespeare's Sonnet 18, “So long as men can breathe or eyes can see, So long lives this, and this gives life to thee,” as the main text content in our piece.</p>
                <p>The major medium of "Loss of Sonnet 18" is a series of videos that record the loss of words being stored and spread. Each video within this artwork is a sequence of 999 images, arranged according to their respective compression iterations. In each iteration, we program to add different types of noises to deliberately degrade the image quality and infuse it with a touch of blur, simulating the gradual erosion of clarity and precision.</p>
                <p>This iterative process is cumulative; the output of one iteration becomes the input for the next, creating a layered narrative of loss. Each subsequent image is not just a standalone representation but an aggregate of all the preceding levels of distortion and decay. This continuous progression encapsulates the core theme of our project - the relentless, incremental diminishment of data integrity, mirroring the inexorable passage of time and the transformative nature of memory and perception that might occur on words.</p>
                <p>The background sounds in videos consist of two parts. One is the morse code of the poem “So long as men can breathe or eyes can see, So long lives this, and this gives life to thee.” It is an echo of machine signals, in contrast to the sound in the audience’s brain, i.e., the echo of human thought. The other is environmental music we subjectively select to match the main idea of this project. With loss deepening, the background sound also becomes distorted and noisy, generating a kind of sound and picture synesthesia feeling.</p>
                <p>We utilize Python with the Pillow library for image processing and Microsoft Azure services for Optical Character Recognition (OCR) and computer vision. We render the video presentation through an HTML5 application.</p>

                <br/>
                <h4>Broader Implications and Conclusion</h4>
                <p>"Loss of Sonnet 18" invites contemplation on the essence of communication in our digital age. It raises questions about the fidelity of text in electronic mediums and draws parallels with ancient methods of text preservation. The project underscores the perpetual yet constantly evolving nature of loss, leaving an indelible impression of fleeting beauty and the ephemeral nature of understanding.</p>
                <p>Beyond the words in "Loss of Sonnet 18," we present not just an art piece but a profound commentary on the transient nature of data and meaning. It’s an invitation to experience, ponder, and engage with the ever-shifting landscape of communication, technology, and human perception.</p>

            </div>,
            story: <div className="story">
                    <div>
                        <blockquote className='quote'>So long as men can breathe or eyes can see, So long lives this, and this gives life to thee. -- Shakespeare, Sonnet 18</blockquote>
                        <blockquote className='quote'>The ship wherein Theseus and the youth of Athens returned from Crete had thirty oars, and was preserved by the Athenians down even to the time of Demetrius Phalereus, for they took away the old planks as they decayed, putting in new and stronger timber in their places, insomuch that this ship became a standing example among the philosophers, for the logical question of things that grow; one side holding that the ship remained the same, and the other contending that it was not the same. -- Plutarch, Life of Theseus 23.1</blockquote>
                        <p>Vaguely, I remember the beginning of it all—it stemmed from a "watermark." Memes, photos, videos—shared and reshared across the internet, layer upon layer, becoming increasingly pixelated, weighed down by watermark after watermark. "Ancestral watermarks," as they’re often mockingly called. We laugh at the notion, but something more seems to lie hidden within, a deeper story to be unearthed.</p>
                        <p>
                            <strong>Forgetting.
                            </strong>This appears to be a new kind of forgetting, a multimodal one native to the internet age. The rise of cloud databases has granted us the ability to upload and share vast amounts of information. Yet, in this process, as these data pass through multiple channels, subject to space limitations, copyright constraints, they become blurred, cropped, and marked. Information is degraded layer by layer until it is nearly unrecognizable. Despite the storage capabilities of cloud databases, the sense of losing something essential, of forgetting, still lingers.</p>
                        <p>
                            <strong>Reinterpretation.
                            </strong>With each step in the transmission and sharing of data, some information isn’t just lost; it’s reinterpreted, giving rise to something new. This phenomenon is fascinating, and three scenarios come to mind:</p>
                        <li>Rumors, or misinformation. Even with mere words—without the complexity of multiple modes—meanings shift as they are passed from person to person.</li>
                        <li>Annotations. I recall a discussion during my PhD with Professor Qu about how different commentaries, written by authors from various eras, annotate the same text collection. This temporal evolution is quite intriguing.</li>
                        <li>Restoration of artifacts. Take, for example, the restoration of Dunhuang murals. This could be considered the “reverse engineering” of generation loss—where later interpreters attempt to recover the original appearance of artifacts.</li>
                        <li>...</li>
                        <br/>
                        <p>Generation loss, and loss generation—this Ship of Theseus-like cycle of iteration and renewal is a common phenomenon in the era of big data. It is fascinating—new interpretations are constantly generated; it is perilous—rumors and misinformation are born from it; it is sorrowful—because even with enormous data storage capabilities, loss and forgetting persist, breaking the illusion of what we once hoped would be eternal.</p>

                        <p>2024, Year of the Wood Dragon – Beginning of Autumn</p>
                        <br/>
                    </div>
                </div>,
            imageList: LossGenerationImgUrlList,
            suppMaterialList: [
                {
                    name: 'PDF',
                    fileLink: 'https://dl.acm.org/doi/10.1145/3641523.3669939'
                }, {
                    name: 'Official Website',
                    fileLink: 'https://s2024.conference-program.org/presentation/?id=artg_205&sess=sess284'
                }, {
                    name: 'Demo Video',
                    fileLink: lossGenerationVideoUrl
                }, {
                    name: 'Slides',
                    fileLink: generationLossSlidesUrl
                },
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    image: LossGenerationImgUrlList[1],
                    time: 'Jul 28, 2024 – Aug 1, 2024',
                    title: 'Loss of Sonnet 18',
                    description: <>
                        <p>
                            This project is an explorative digital art installation that delves into the phenomenon of generation loss - the inevitable degradation of information (e.g., words) quality through copying and propagation. It transcends the technical realm to probe how this concept applies to the transmission and transformation of words and meanings through time and technology.
                        </p>
                        <p>
                            It consists of a series of videos illustrating the loss of words themselves and their meaning, combined with real-time interpretation from both humans and machine. The project allows the audience to find a border of loss, beyond which, information of words might change.
                        </p>
                    </>
                },
                secondaryImageInfo: {
                    image: LossGenerationImgUrlList[0],
                    title: 'Background',
                    description: <div>
                        <p className='description'>In analogue recordings, a progressive loss of quality that occurs every time a tape, film, or vinyl disc is copied. The problem of generation loss has been reduced but not eradicated in digital media.
                            <span>— A Dictionary of Media and Communication (1 ed.), 2011
                            </span>
                        </p>
                        <p className='description'>Generation loss is the loss of quality between subsequent copies or transcodes of data.
                            <span>— Wikipedia.
                                <a href='https://en.wikipedia.org/wiki/Generation_loss'>Generation Loss</a>.</span>
                        </p>
                    </div>
                },
                awardImageInfo: {
                    image: LossGenerationImgUrlList[5],
                    awardLogoList: LossGenerationAwardLogoList
                }
            }
        },
        {
            category: [
                paperCategory.ALL, paperCategory.CSS, paperCategory.DR
            ],
            teaser: LonelyIslandStoryUrl,
            award: [
                dataArtAwardCategory.CHINAVISAP2024, dataArtAwardCategory.VISAP2023, dataArtAwardCategory.INFOPLUS, dataArtAwardCategory.IIB2023,
            ],
            year: '2023-2024',
            title: 'Posts with No Response: The Island of Loneliness',
            titleShort: 'The Island of Loneliness',
            classification: 'PHILOSOPHICAL REFLECTION',
            theme: [
                'Digital World', 'Social Isolation'
            ],
            authorList: [
                'Junxiu Tang',
                'Rui Sheng',
                'Yifang Wang',
                'Xinhuan Shu',
                'Xiaojiao Chen',
                'Tan Tang',
                'Yingcai Wu'
            ],
            venue: 'IEEE VIS Arts Program (accepted in two tracks: Pictorial and Artwork)',
            venueShort: 'VISAP2023',
            mediaCoverage: [
                {
                    name: 'HKUST Lee Shau Kee Library',
                    title: 'Backstory of the “Island of Loneliness”',
                    fileLink: 'https://library.hkust.edu.hk/sc/the-island-of-loneliness-china-visap/'
                }, {
                    name: 'Art Visualization (WeChat)',
                    title: 'China VISAP\'24 | Art project report 01',
                    fileLink: 'https://mp.weixin.qq.com/s/FL2RswucK6MWMOtHMiIu2Q'
                },
            ],
            introduction: <div>
                <p>Loneliness and isolation are eternal emotions in human beings. Technological advancements create ample avenues, like social medias, for individuals to articulate themselves and record emotions. However, the sense of loneliness has never vanished, as their expressions are easily buried in the digital stream. We analyze tweets that express loneliness during holiday seasons but receive few responses. By superimposing digital charts on physical models, we visualize these lonely posts and generate the island of loneliness. We aim to reveal the complexities of human emotions in the digital age and reflect on the interconnections between technology, solitude, and social communication.</p>
            </div>,
            story: <div className="story">
                    <div>
                        <h4>Origin</h4>
                        <p>I try to trace the origin of this project. Yet, ten minutes later, I still can’t pinpoint the first moment the idea came to be. Perhaps, as the title suggests—The Island of Loneliness—loneliness itself isn’t something that suddenly begins in an explicit instant. Maybe it’s something that has existed alongside civilization, entwined with life itself, lingering in the hearts of each of us coauthors for a very long time.</p>
                        <p>Junxiu later recalled that the initial concept might go back to VISAP 2021, where the theme was (dis)connected, and ChinaVISAP, where the theme was bridges. Without bridges, there is no connection. Each person becomes an isolated island.</p>
                        <p>The earliest record I found was a casual chat on February 9, 2023, about what we’d plan for this year’s art, along with a tweet reposted on February 19th--</p>
                        <div className='story-image-wrapper'>
                            <div className='story-image-div'><Image src={LonelyIslandStoryImgUrl1}/></div>
                            <div className='story-image-div'><Image src={LonelyIslandStoryImgUrl2}/></div>
                        </div>

                        <br/>
                        <h4>Medium</h4>
                        <p>The tweet mentioned an aunt banned from WeChat. From this, we started to ponder: what does loneliness signify and represent in contemporary society? In the age of the internet, with the explosion of information and the construction of virtual social networks, the distances between us seem to shrink. Even separated by miles, we can still text, chat, and video call through social media.</p>
                        <p>Our WeChat accounts hold hundreds, even thousands, of contacts. Our social media follows interesting people and events worldwide. Sites like Xiaohongshu and Bilibili bring daily shares about life and learning… In such a context, “loneliness” may sound melodramatic. But is it truly so?</p>
                        <p>Those moments when we scroll through our contacts but find no one to talk to, when we see the brilliant lives of distant others while feeling aimless, those nights when endless scrolling leaves us feeling empty… Beneath the noise of the internet, where do our souls find rest? Are the confusions about life, emotions, time, or even the universe truly eased by these virtual connections? Perhaps, sometimes. But maybe not.</p>
                        <p>Online social media—a product of modern civilization—seems to have given loneliness a new meaning.</p>
                        <p>As a PhD candidate previously working on a survey about social media visual analytics, I remember vividly how pioneers in visualization created outstanding works exploring issues like opinion leaders, topic evolution, and information diffusion, all of which touch on social science concepts such as communication and group dynamics.</p>
                        <p>So, we thought: what if we went the other way? Beyond mainstream media and influencers, what about the countless ordinary people inhabiting social media?</p>
                        <li>Perhaps they get few shares or comments.</li>
                        <li>Perhaps they are whispering to themselves late at night.</li>
                        <li>Perhaps they carry complex emotions beneath the likes they receive.
                        </li>
                        <li>Perhaps, more often than not, they are lonely.
                        </li>
                        <p>So, we got to work. In this phase, we chose the most direct platform—Twitter—and the most straightforward keywords: lonely, loneliness... We tried to gather the murmurs of thousands of ordinary people in the digital world—those silent words without retweets or comments, speaking of loneliness itself, and ultimately built an island constructed from these quiet echoes.</p>

                        <br/>
                        <h4>Further Exploration?</h4>
                        <p>At times, we may feel like the 52-hertz whale, singing either joyfully or sorrowfully, with our calls unheard by our kind. This “whale” could be the elderly person banned from WeChat, or perhaps each one of us.</p>
                        <p>As this phase of the project draws to a close, we return to reflect on the initial question: what is loneliness, really?</p>
                        <li>Is it the grass beneath our feet, growing and withering each year?</li>
                        <li>Is it the waves crashing against the shore?</li>
                        <li>Is it the clouds drifting and separating, then finally fading?</li>
                        <br/>
                        <li>Is it the golden autumn leaves, or the windmill bathed in a rosy sunset?</li>
                        <li>Is it the songs sung on stage, the rustle of birds returning to the forest?</li>
                        <li>Is it the silhouette against the evening sun, or the reflection in a subway window?</li>
                        <br/>
                        <li>Is it the fear of facing the unknown and making choices?</li>
                        <li>Is it the clamor and confusion amid the noise?</li>
                        <li>Is it that she, far away, will always remain out of reach?</li>
                        <li>Or is it the creased, yellowing neck of someone on screen?</li>
                        <li>Is it time moving forward, while you remain in the past?</li>
                        <br/>
                        <li>It's like a poison, like a poppy flower, drawing us into this aching, restless, unrequited, yet secretly thrilling, gratifying, even prideful—almost “pathological” feeling.</li>
                        <br/>
                        <p>This is an ongoing experimental art project, created by some lovely data visualization researchers and data art enthusiasts. We hope to bring future versions—2.0, 3.0, and beyond—sharing more about the meaning of loneliness.</p>

                        <br/>
                        <p>2023, Year of the Water Rabbit – Descent of Frost</p>
                        <br/>
                    </div>
                </div>,
            storyImageList: [
                LonelyIslandStoryImgUrl1, LonelyIslandStoryImgUrl2
            ],
            imageList: LonelyIslandStoryImgUrlList,
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: LonelyIslandVideoUrl
                },
                {
                    name: 'PDF',
                    fileLink: LonelyIslandPaperUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: LonelyIslandVideoUrl
                },
                {
                    name: 'VISAP2023 Official Website',
                    fileLink: 'https://visap.net/2023/contributions/posts-with-no-response-the-island-of-loneliness'
                }, {
                    name: 'Info+ 2023 Official Website',
                    fileLink: 'https://informationplusconference.com/2023/#program'
                },
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    image: LonelyIslandStoryImgUrlList[15],
                    time: '2023, 2024',
                    title: 'Posts with No Response: The Island of Loneliness',
                    description: 'Loneliness and isolation are eternal emotions in human beings. Technological advancements create ample avenues, like social medias, for individuals to articulate themselves and record emotions. However, the sense of loneliness has never vanished, as their expressions are easily buried in the digital stream. We analyze tweets that express loneliness during holiday seasons but receive few responses. By superimposing digital charts on physical models, we visualize these lonely posts and generate the island of loneliness. We aim to reveal the complexities of human emotions in the digital age and reflect on the interconnections between technology, solitude, and social communication.'
                },
                secondaryImageInfo: {
                    image: LonelyIslandStoryImgUrlList[0],
                    title: 'Metaphor',
                    description: <>
                        <p className='description'>
                            In the digital world, social media platforms can be likened to an expansive, boundless sea brimming with many semantic data. Individuals continuously contribute their emotions, feelings, and opinions to the torrential stream of information.
                        </p>
                        <p className='description'>
                            Each post acts as a metaphorical stone cast into the sea, with some carrying significant weight, size, or other captivating features that generate continuous ripples and water flowers, sparking mass responses within the crowd.
                        </p>
                        <p className='description'>
                            However, the majority of posts bear lightweight and unremarkable appearances, failing to generate any notable ripples or water flowers. These posts akin to grains of sand, simply sinking to the seabed. While they may temporarily resurface through topic resonance when certain keywords are searched, they primarily exist as unnoticed and unattended sedimentations of information.
                        </p>
                    </>
                },
                awardImageInfo: {
                    image: LonelyIslandStoryImgUrlList[7],
                    awardLogoList: LonelyIslandAwardLogoList
                }
            }
        },
        {
            category: [
                paperCategory.ALL, paperCategory.DH, paperCategory.DR
            ],
            teaser: shijingUrl,
            title: 'Explore Mindfulness Without Deflection: A Data Art Based On The Book Of Songs',
            titleShort: 'Explore Mindfulness without Deflection',
            year: 2022,
            classification: 'HUMANITY APPRECIATION',
            theme: [
                'Poem', 'Culture'
            ],
            authorList: [
                'Yifang Wang',
                'Yifan Cao',
                'Junxiu Tang',
                'Yang Wang',
                'Huamin Qu',
                'Yingcai Wu'
            ],
            venue: 'IEEE VIS Arts Program',
            venueShort: 'VISAP2021',
            award: [
                dataArtAwardCategory.VISAP2021, dataArtAwardCategory.ElectricDreams2022, dataArtAwardCategory.IIB2022
            ],
            mediaCoverage: [
                {
                    name: 'HKUST VisLab',
                    title: '[VISAP 2021] Winter solstice: a day to sit by the stove, melt snow and read poems',
                    fileLink: 'https://mp.weixin.qq.com/s/mMoqtZrJInwg02yGTLQ3TA'
                },
                {
                    name: 'The Paper · Art Class',
                    title: 'Please, stop cramming the text so densely',
                    fileLink: 'https://mp.weixin.qq.com/s/3GJ11TLT9YALqaJ9hQ5TmA'
                },
                {
                    name: 'Yizhi Li (WeChat)',
                    title: 'Adding some design to data: the many possibilities of data visualization',
                    fileLink: 'https://mp.weixin.qq.com/s/-sbNslBgCN5hHGnStHAhHQ'
                },
                {
                    name: 'HKUST (Guangzhou) · Information Hub',
                    title: 'CMA event | The first CMA international symposium and exhibition: Electric Dreams',
                    fileLink: 'https://mp.weixin.qq.com/s/U_mpaS9UQoNIy0OgVoPIHw'
                }, {
                    name: 'CMA Thrust Symposium',
                    title: 'Electric Dreams - the 1st CMA International Symposium and Exhibition',
                    fileLink: 'https://cma.hkust-gz.edu.cn/electric-dreams/'
                },
            ],
            introduction: <div>
                <p>The Book of Songs is regarded as the origin of Chinese literature and has a prolonged impact on Chinese culture, aesthetics, and morality. In this work, we have analyzed the 305 poems in The Book of Songs from different dimensions. We aim to learn how various poetic imageries connect abstract themes and subjective emotions at the micro level, and how the poems connect people today and ancestors to understand the universal, everlasting, and poetical human lives at the macro level.</p>
            </div>,
            story: <div className="story">
                    <div>
                        <p>How to interpret and carry forward traditional Chinese culture through data visualization is something I have wanted to try since I first entered this field. In the early summer of 2021, I met Yifan, with a background in Chinese literature, and Junxiu, with a background in digital media. After a few casual conversations, the three of us immediately clicked and decided to start with The Book of Songs, the first anthology of poetry in China. As the origin of Chinese poetic development, we believe that The Book of Songs possesses a unique and magical blend of content, emotions, and spirit, which sparked the subsequent flourishing of Chinese poetry, from the Chu Ci and Han Fu to the Tang and Song poetry and the Yuan operas. The cicadas hadn’t yet begun to sing, but our hearts were already restless with excitement.</p>
                        <p>By coincidence, the top visualization conference we attend each year (VISAP2021) was calling for submissions for its art project. We decided to take this opportunity to see if we could create a prototype. Within a month, we used our spare time to complete the first version (V1) of our “extracurricular project”—a static infographic titled Thoughts Without Evil. Fortunately, our work was accepted by the art project. At the conference report that concluded at the end of October, our piece attracted wide attention and discussion, including from many scholars and artists involved in Art + Tech. Their interest greatly encouraged us. We decided to take it a step further—to transform our static infographic into an interactive website. Thus, the interactive version of Thoughts Without Evil (V2) came to be. We hope that this new interactive and visual format can inspire the general public to explore The Book of Songs more deeply and encourage researchers in poetry and literature to investigate from a quantitative perspective.</p>
                        <p>We often joke that this “side project” truly comes from our “love-powered engine.” Will the Book of Songs project extend to v3, v4…? Will we explore and create other digital art pieces related to traditional culture? With limited time and energy, we can’t say for sure. But we still believe: what we hold close to heart will inevitably resonate in return.</p>

                        <br/>
                        <p>2021, Year of the Metal Ox – Winter Solstice</p>
                        <br/>
                    </div>
                </div>,

            imageList: Visap2021ImgUrlList,
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://wangyifang.github.io/the-book-of-songs/'
                },
                {
                    name: 'PDF',
                    fileLink: visap2021PaperUrl
                },
                {
                    name: 'Demo Video',
                    fileLink: visap2021VideoUrl
                },
                {
                    name: 'Supp Material',
                    fileLink: visap2021SuppUrl
                }, {
                    name: 'Slides',
                    fileLink: visap2021SlidesUrl
                }, {
                    name: 'Talk',
                    fileLink: 'https://www.youtube.com/watch?v=5fNTfPpeXQs'
                },
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    image: Visap2021ImgUrlList[2],
                    time: '2021, 2022',
                    title: 'Explore Mindfulness Without Deflection: A Data Art Based On The Book Of Songs',
                    description: <p>
                        The Book of Songs is regarded as the origin of Chinese literature and has a prolonged impact on Chinese culture, aesthetics, and morality. In this work, we have analyzed the 305 poems in The Book of Songs from different dimensions. We aim to learn how various poetic imageries connect abstract themes and subjective emotions at the micro level, and how the poems connect people today and ancestors to understand the universal, everlasting, and poetical human lives at the macro level.
                    </p>
                },
                secondaryImageInfo: {
                    image: Visap2021ImgUrlList[1],
                    title: 'The Book of Songs',
                    description: <p className='description'>
                        The Book of Songs is widely acknowledged as the origin of traditional Chinese culture and highly impacted the whole East Asian culture. It is officially assembled by the famous founder of Confucianist, Confucius, who lived in the Late Zhou Dynasty around 3000 years ago. This epoch is considered paralleled with the Axial Period of world history, and Confucianist is regarded as one of the fundamental East Asian philosophies. The Book of Songs represents secular and religious values Confucius approved in accord with his own philosophical system, which brings a profound impact on traditional Chinese culture, aesthetics, and morality. Recorded from 1100 BC to 500 BC, The Book of Songs consists of 305 poems with three genres, namely, Songs, Odes and Epics, and Hymns [14]. Across different genres, the poems cover various themes to portray the whole society in the Late Zhou Dynasty, including not only ballads, folk-customs of ordinary people, but also sacrifice, banquet, and the musical dance of nobility.
                    </p>
                },
                awardImageInfo: {
                    image: Visap2021ImgUrlList[0],
                    awardLogoList: Visap2021AwardLogoList
                }
            }
        }, {
            category: [
                paperCategory.ALL, paperCategory.DH, paperCategory.DR
            ],
            teaser: ChinaInMapsImgUrl,
            year: '2022-2024',
            titleShort: 'China in Maps',
            title: 'China in Maps: 500 Years of Evolving Images',
            classification: 'HUMANITY APPRECIATION',
            theme: ['Culture'],
            authorList: [
                'Kentaro Takahira',
                'Boyu Li',
                'Wai Tong',
                'Linping Yuan',
                'Yifang Wang',
                'Leni Yang',
                'Huamin Qu',
                'etc.'
            ],
            venue: '',
            venueShort: '',
            award: [],
            mediaCoverage: [],
            introduction: <div>
                <p>Step into a world prior to the age of GPS and wayfinding within our fingertips.</p>
                <p>How did people create and utilize maps centuries ago? When we examine old maps, besides appreciating their beauty, we may ponder why they were not primarily created for navigation and did not accurately describe geographic reality. Here is an era of ancient mapmaking when representation of reality was not of foremost concern.</p>
                <p>The HKUST Library has amassed a significant collection of Western printed maps of China spanning the 16th to 19th centuries. Since 2015, thanks to the generous donation by Dr. Ko Pui-Shuen, this collection was further enriched. The exhibition features a curated selection of items from this valuable collection, highlighting how the land and geography of China were portrayed by European and Chinese mapmakers.</p>
                <p>These maps guide us in transitioning from viewing the world through our contemporary lens to embracing the perspectives of mapmakers from different times in the past. Their presentations may break perception stereotypes, challenge our preconceived notions about the advancement of knowledge and technology throughout history, and impart fresh understanding of ancient maps and mapmaking.</p>
                <p>To enrich the stories we convey, the exhibition includes important maps and artifacts beyond those of the HKUST collection. While most of these are image reproductions, there are also notable exhibits such as a special original map on loan from local collector Mr. Ronald Tham and Nestorian crosses from the University Museum and Art Gallery of the University of Hong Kong. We express our deepest appreciation for their support of this exhibition.</p>
            </div>,
            story: <Tabs defaultActiveKey="1"></Tabs>,
            imageList: ChinaInMapsImgUrlList,
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://library.hkust.edu.hk/china-in-maps/'
                },
                // {name: 'PDF', fileLink: './xxxxxx'},
                {
                    name: 'Demo Video',
                    fileLink: ChinaInMapsVideoUrl
                },
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    time: '2022-2024',
                    image: ChinaInMapsImgUrlList[0],
                    title: 'China in Maps: 500 Years of Evolving Images',
                    description: <>
                        <p className='description'>Step into a world prior to the age of GPS and wayfinding within our fingertips.</p>
                        <p className='description'>How did people create and utilize maps centuries ago? When we examine old maps, besides appreciating their beauty, we may ponder why they were not primarily created for navigation and did not accurately describe geographic reality. Here is an era of ancient mapmaking when representation of reality was not of foremost concern.</p>
                        <p className='description'>The HKUST Library has amassed a significant collection of Western printed maps of China spanning the 16th to 19th centuries. Since 2015, thanks to the generous donation by Dr. Ko Pui-Shuen, this collection was further enriched. The exhibition features a curated selection of items from this valuable collection, highlighting how the land and geography of China were portrayed by European and Chinese mapmakers.</p>
                        <p className='description'>These maps guide us in transitioning from viewing the world through our contemporary lens to embracing the perspectives of mapmakers from different times in the past. Their presentations may break perception stereotypes, challenge our preconceived notions about the advancement of knowledge and technology throughout history, and impart fresh understanding of ancient maps and mapmaking.</p>
                        <p className='description'>To enrich the stories we convey, the exhibition includes important maps and artifacts beyond those of the HKUST collection. While most of these are image reproductions, there are also notable exhibits such as a special original map on loan from local collector Mr. Ronald Tham and Nestorian crosses from the University Museum and Art Gallery of the University of Hong Kong. We express our deepest appreciation for their support of this exhibition.</p>
                    </>
                },
                secondaryImageInfo: {
                    image: ChinaInMapsImgUrlList[1],
                    title: '',
                    description: 'Kunyu Wanguo Quantu [Complete Geographical Map of all the Kingdoms of the World]'
                },
                awardImageInfo: {
                    image: ChinaInMapsImgUrlList[0],
                    awardLogoList: []
                }
            }
        }, {
            category: [
                paperCategory.ALL, paperCategory.DH, paperCategory.DR
            ],
            teaser: dunhuangUrl,
            year: 2022,
            titleShort: 'Imagination to the Universe',
            title: 'Imagination to the Universe: Mingling the Ancient and the Present',
            classification: 'HUMANITY APPRECIATION',
            theme: ['Culture'],
            authorList: [
                'Junxiu Tang',
                'Yifang Wang',
                'Jiayi Zhou',
                'Xinhuan Shu',
                'Tan Tang',
                'Huamin Qu',
                'Yingcai Wu'
            ],
            venue: '',
            venueShort: '',
            award: [],
            mediaCoverage: [],
            story: <div className="story">
                    <div>
                        <p>
                            For thousands of years, the descendants of China have never ceased to imagine and explore the boundless sky and vast universe. From the self-questioning of "Where does the sky’s edge lie?" to the romantic myth of "Wu Zhi, sleepless, leans on the cassia tree as dew-wet hare feet fly through the night," from the time-perception embodied in "The Big Dipper tilts as the Southern Dipper sinks," to the natural insight of "The sky is like a lid, the earth like an overturned bowl, each high at the center and low at the edges," and to the present, with Shenzhou, Tiangong, Yutu, and Zhurong, we have recorded myths, penned poetry, and imbued the cosmos with rich imagination and delicate emotions. Alongside, we have pursued knowledge and sought truth, attempting to break free from the shackles to explore the vast universe. The Flight to the Sky, Embrace of the Moon, Gathering of Stars series adopts the artistic style of Dunhuang murals, blending ancient Chinese legends and texts with contemporary aerospace exploration missions. The theme "Visible Classics" unfolds across three layers of self-awareness, external exploration, and the arrival at the unknown, interpreting the Chinese cultural heritage and technological exploration across space and time, and thus unfolds in three chapters: Flight to the Sky: Breaking the Chaos, Embrace of the Moon: Conversations with Chang'e, and Gathering of Stars: Uniting the Heavens.
                        </p>

                        <br/>
                        <h4>Flight to the Sky: Breaking the Chaos</h4>
                        <p>
                            "Flight to the Sky" reflects humanity’s evolving understanding of the heavens. The Book of Jin records, "The sky is round like an umbrella, and the earth is square like a chessboard." This "round sky, square earth" cosmology is a significant ancient understanding of the universe. This piece begins with the caisson patterns of the Dunhuang caves, using motifs like petal scrolls and circular florals to depict the ancient worldview. Gazing up from below, it appears like a colossal lid covering the sky. Around and within this lid are dark, unexplored spaces, symbolizing the uncharted and boundless cosmos.
                        </p>
                        <p>
                            Through AR interaction, the viewer is transported centuries forward to present-day China. The artwork depicts the rockets launched as part of China's manned space program up to May 2022, with the center showcasing the Chinese space station. Twenty Shenzhou spacecraft are arranged counterclockwise according to their launch dates, piercing through the "round sky, square earth" caisson, breaking through the ancient conception of the cosmos. From unmanned missions to cargo and crewed missions, to orbit docking, spacewalking, and space station occupancy, the unrelenting efforts of several decades have seen the Chinese people embark on the journey of space exploration, reaching into the deep space and venturing into the unknown.
                        </p>

                        <br/>
                        <h4>Embrace of the Moon: Conversations with Chang'e</h4>
                        <p>
                            The moon, our nearest celestial neighbor, has long been a subject of sentimental musings and the first stop on the path of space exploration. Sitting under a tree with a jug of wine and a zither, one might find solace, even in solitude, with only the moonlight for company.</p>
                        <li>Under the bright moon, do you see those faint shadows? Could it be Wu Gang chopping down the cassia tree? Or perhaps the jade rabbit and toad frolicking nearby?</li>
                        <li>As the moonlight glows, do you see the clouds around the halo? Could it be Chang'e herself, dancing gracefully outside the palace?</li>
                        <li>Across a thousand miles, do you see those wisps of moonlight like drifting smoke? Could they be the dust kicked up by Wangsher's chariot, rushing across the night sky?</li>
                        <br/>

                        <p>In the silence of the night, as the wind stirs and cicadas sing, we look up at the bright moon, a motif found countless times in Chinese literature. The romantic essence of the Chinese soul endows the moon with numerous poetic names.</p>
                        {/* <p>“此时瞻白兔，直欲数秋毫。”这是杜甫避乱蜀中望月思乡的感叹；“古祠近月蟾桂寒，椒花坠红湿云间。”这是李贺巫山楚魂寻梦到巫山的哀婉； “天汉看珠蚌，星桥视桂花。”这是庚信撒月上桂 花散于夜空幻化做星斗的妙想…</p> */}
                        <p>We compiled various ancient names for the moon found in classical literature and displayed them in AR under the moonlit sky. The AR visualization represents these names as a word cloud, where the size of each word indicates its frequency. Terms like "toad," "rabbit," and "cassia" dominate, referencing myths. These names appear as silhouettes on willow branches, reminiscent of the billowing ribbons of celestial beings depicted in Dunhuang murals, embodying both the timeless poetry and myth associated with the moon. Circling the moon is a sequence of star trails, representing the launch dates and durations of China’s lunar missions (Chang'e and Yutu series), guarding the moon and Earth alongside ancient stars. Now, when people gaze at the moon, they not only see myths but also the envoys from Earth, reaching out across the sky.</p>
                        {/* <p>「揽月：话婵娟」以古代典籍中月的别称以及现代的月球探测任务为数据，古今中与月有关的故事在月色下交融。</p>
            <p>月晕周围则出现了一道道星轨，记录着奔月系列航天器（嫦娥系列和玉兔系列）的发射时间和停留时长，与远古的众星一起，守护着月亮与地球。</p>
            <p>从此，人们遥望月亮的时候，不仅仅只有神话，还有可以与来自地球的使者对话。</p> */}

                        <br/>
                        <h4>Gathering of Stars: Uniting the Heavens</h4>
                        <p>The exploration of the vast starry sky has been an ongoing endeavor. China's planetary exploration mission is named Tianwen, with the first Mars mission called Tianwen-1. In July 2020, Tianwen-1, carrying the Zhurong rover, embarked on its journey to Mars. The name Tianwen, drawn from Qu Yuan's long poem, symbolizes the Chinese people's resilient pursuit of truth and their cultural heritage of exploring nature and the cosmos, capturing the boundless quest for scientific and technological innovation.</p>
                        <p>By combining the ancient text Tianwen and modern Mars exploration events, Gathering of Stars uses the border patterns of Dunhuang murals as the primary imagery, portraying China’s exploration of the most distant planet yet. The bottom half incorporates square patterns from mural borders and original text from Tianwen, color-coded to reflect themes: questions about heaven (blue), earth (green), deities (red), and humanity (orange).</p>
                        <p>In AR, the original text appears on these border patterns. Additionally, we categorized the questions on heaven, earth, and gods, and represented them with corresponding color-coded area charts on lotus petals above. The petal size represents the frequency of related lines in the poem.</p>
                        <p>The outermost layer of the AR features flying ribbons, chronologically depicting the major milestones of Tianwen-1 and Zhurong. This reflection of two years of groundbreaking advancements marks the steps China has taken toward exploring the mysteries of distant planets.</p>

                        <h4>Conclusion</h4>
                        <p>From breaking through the primeval chaos to reveal the true heavens and earth, to reaching for the moon and witnessing Chang'e’s beauty, and finally to exploring Mars and uncovering planetary secrets… we continue our quest for truth and strive to coexist harmoniously with the natural cosmos. We transcend boundaries, journeying ever farther into interstellar space, leaving traces of China’s ancient stories and texts across the vast universe.</p>

                        <br/>
                        <p>2024, Year of the Wood Dragon – Beginning of Autumn</p>
                        <br/>
                    </div>
                </div>,


            imageList: DunhuangImgUrlList,
            suppMaterialList: [
                {
                    name: 'Project Page',
                    fileLink: 'https://fs-tm-gs.github.io/'
                },
                // {name: 'PDF', fileLink: './xxxxxx'},
                // {name: 'Demo Video', fileLink: './xxxxxx'},
                // {name: 'Slides', fileLink: './xxxxxx'},
                // {name: 'Talk', fileLink: './xxxxxx'},
            ],
            detailPageData: {
                exihibitionImageInfo: {
                    time: '2022',
                    image: DunhuangImgUrlList[1],
                    title: 'Imagination to the Universe: Mingling the Ancient and the Present',
                    description: <p className='description'>
                        For thousands of years, the descendants of China have never ceased to imagine and explore the boundless sky and vast universe. We have recorded myths, penned poetry, and imbued the cosmos with rich imagination and delicate emotions. Alongside, we have pursued knowledge and sought truth, attempting to break free from the shackles to explore the vast universe. The Flight to the Sky, Embrace of the Moon, Gathering of Stars series adopts the artistic style of Dunhuang murals, blending ancient Chinese legends and texts with contemporary aerospace exploration missions. The theme "Visible Classics" unfolds across three layers of self-awareness, external exploration, and the arrival at the unknown, interpreting the Chinese cultural heritage and technological exploration across space and time, and thus unfolds in three chapters: Flight to the Sky: Breaking the Chaos, Embrace of the Moon: Conversations with Chang'e, and Gathering of Stars: Uniting the Heavens.
                    </p>
                },
                secondaryImageInfo: {
                    image: DunhuangImgUrlList[3],
                    title: '',
                    description: ''
                },
                awardImageInfo: {
                    image: DunhuangImgUrlList[5],
                    awardLogoList: []
                }
            }
        },
        // {
        // category: [paperCategory.ALL, paperCategory.DR],
        // teaser: vis22ReflectionUrl,
        // title: '[Project for Fun] My VIS2022 Reflection',
        // authorList: ['Yifang Wang'],
        // venue: '',
        // venueShort: '',
        // award: [],
        // suppMaterialList: [
        //     {name: 'Project Page', fileLink: 'http://vis2022reflect.hkustvis.org/'},
        //     // {name: 'PDF', fileLink: './xxxxxx'},
        //     // {name: 'Demo Video', fileLink: './xxxxxx'},
        //     // {name: 'Slides', fileLink: './xxxxxx'},
        //     // {name: 'Talk', fileLink: './xxxxxx'},
        // ]
        // },
    ],
    experiencePage: [
        {
            category: 'Experience',
            institute: 'Department of Computer Science, Florida State University',
            institutionLogo: fsuUrl,
            location: 'Tallahassee, USA',
            timePeriod: 'Aug. 2025 - Present',
            role: 'Assistant Professor'
        },
        {
            category: 'Experience',
            institute: 'Kellogg School of Management, Northwestern University',
            institutionLogo: nuUrl,
            location: 'Evanston, USA',
            timePeriod: 'Sept. 2022 - Jul. 2025',
            role: 'Post-Doctoral Fellow',
            supervisor: 'Prof. Dashun Wang'
        },
        {
            category: 'Experience',
            institute: 'VisLab, HKUST',
            institutionLogo: hkustUrl,
            location: 'Hong Kong, China',
            timePeriod: 'Sept. 2018 - Aug. 2022',
            role: 'PhD',
            supervisor: 'Prof. Huamin Qu'
        },
        {
            category: 'Experience',
            institute: 'Zhejiang Lab',
            institutionLogo: zhejianglabUrl,
            location: 'Hangzhou, China',
            timePeriod: 'Sept. 2020 – Apr.2021',
            role: 'Visiting Scholar',
            supervisor: 'Prof. Yingcai Wu'
        }, {
            category: 'Experience',
            institute: 'State Key Lab of CAD & CG, Zhejiang University',
            institutionLogo: zjuUrl,
            location: 'Hangzhou, China',
            timePeriod: 'Nov. 2019 – Apr.2020',
            role: 'Visiting Scholar',
            supervisor: 'Prof. Yingcai Wu'
        }, {
            category: 'Experience',
            institute: 'State Key Lab of CAD & CG, Zhejiang University',
            institutionLogo: zjuUrl,
            location: 'Hangzhou, China',
            timePeriod: 'Sept. 2016 - Jun. 2018',
            role: 'Research Assistant (UG)',
            supervisor: 'Prof. Yingcai Wu'
        }, {
            category: 'Research Services',
            role: 'Program Committee',
            venueList: ['IEEE VIS Conference (2026)', "ACM CHI Conference (2026)", "AI4SciSci Workshop (2025-2026)", "ACM Multimedia (2026)", 'IEEE PacificVis Conference (TVCG Journal Track, 2025-2026)', 'IEEE PacificVis Conference (Conference Track, 2026)', "VIS x GenAI workshop (2026)", "VIS Art Program (VISAP, 2026)", 'IEEE VIS Conference (VAST, InfoVis, and SciVis) Short Paper (VIS Short Paper, 2023-2025)', 'IEEE VIS @VAHC (16th Workshop on Visual Analytics in Healthcare, 2025)', 'IEEE VIS @VISAP, 2025']
        },
        {
            category: 'Research Services',
            role: 'Organization Committee',
            venueList: ['IEEE VIS Panel (2024): What Do Visualization Art Projects Bring to the VIS Community?']
        }, {
            category: 'Research Services',
            role: 'Conference Review',
            venueList: [
                'IEEE VIS Conference (VAST, InfoVis, and SciVis) (VIS, 2019-2025)',
                'ACM Conference on Human Factors in Computing Systems (CHI, 2023-2025)',
                'ACM CHI Late-Breaking Work (2023-2025)',
                'IEEE Eurographics / VGTC Symposium on Visualization (EuroVis, 2025)',
                'IEEE Pacific Visualization Symposium (PacificVis, 2021-2025)',
                'Computer Science Review (CSR, 2024)',
                'China Visualization and Visual Analytics Conference (ChinaVis, 2020-2025)',
                'International Symposium of Chinese CHI (ChineseCHI, 2022)',
                'International Conference on Computational Social Science (IC2S2, social science conference) (2024)',
                'Scientometrics (2024)'
            ]
        }, {
            category: 'Research Services',
            role: 'Journal Review',
            venueList: ['IEEE Transactions on Visualization and Computer Graphics (TVCG, 2021-2024)', 'IEEE Computer Graphics and Applications (CG\&A, 2021-2023)', 'Visual Informatics (VI, 2023-2024)', 'Computer Science Review (2024)']
        }, {
            category: 'Teaching',
            role: 'Instructor',
            institution: 'Florida State University',
            title: 'CIS 4930 / CIS 5930: Introduction to Data Visualization (Fall 2026)',
            homepageUrl: 'https://wangyifang.github.io/fsu-CIS-4930-5930-Fall-2026/'
        },
        {
            category: 'Teaching',
            role: 'Instructor',
            institution: 'Florida State University',
            title: 'ENT 4153: Data Science Entrepreneurship (Spring 2026)',
            homepageUrl: 'https://wangyifang.github.io/fsu-ENT4153-spring-2026/'
        }, {
            category: 'Teaching',
            role: 'Instructor',
            institution: 'Florida State University',
            title: 'CAP 5726: Introduction to Computer Graphics (Fall 2025)',
            homepageUrl: 'https://wangyifang.github.io/CAP4730-CAP5726-2025-fall/'
        }, {
            category: 'Teaching',
            role: 'Teaching Assistant Coordinator (TAC)',
            institution: 'The Hong Kong University of Science and Technology',
            title: 'CSE Department, for two years (2020-2022)'
        }, {
            category: 'Teaching',
            role: 'Teaching Assistant',
            institution: 'The Hong Kong University of Science and Technology',
            title: 'COMP 2711: Discrete Mathematical Tools for Computer Science'
        }, {
            category: 'Teaching',
            role: 'Teaching Assistant',
            institution: 'The Hong Kong University of Science and Technology',
            title: 'COMP 4431: Multimedia Computing'
        },

        // {category: 'R&D', teaser: delphiUrl, title: 'Delphi: AI-powered Visual Analytics Solutions for Communication and Presentation Coaching', introduction: 'The project aims to develop AI-based visual analytics techniques and visualization systems to assist both coaches and public speaking trainees to conduct better presentation training. The audio, text, gesture and posture of the presentations is quantitatively analyzed to guide efficient presentation training.'},
        // {category: 'R&D', teaser: urbanUrl, title: 'People-Aware Smart City: A People-Centered Integration, Mining and Decision Framework', introduction: 'The project proposed a people-aware smart city framework, which integrates data extracted continuously from people (air quality data and financial market data), discovers people’s needs from integrated multi-source data, and finally determines the best resource allocation plans to satisfy people’s needs.'},
        // {category: 'R&D', teaser: pulse2Url, title: 'Pulse: Data-Driven Smart Campus', introduction: 'The project aims to promote a smart campus which supports effective and smart decision-makings through the combined power of IoT devices, big data, and AI.'},
    ],
    contactPageSM: [
        {
            platform: 'CV',
            link: cvUrl,
            content: 'CV',
            platformLogo: cvIconUrlsm
        }, {
            platform: 'Email',
            link: 'mailto:yifang.wang@fsu.edu',
            content: 'yifang.wang@fsu.edu',
            platformLogo: emailIconUrlsm
        }, {
            platform: 'Google Scholar',
            link: 'https://scholar.google.com/citations?user=3qWVVUwAAAAJ&hl=en',
            content: 'Yifang Wang',
            platformLogo: scholarIconUrlsm
        }, {
            platform: 'Twitter',
            link: 'https://twitter.com/yifanginhz',
            content: '@yifanginhz',
            platformLogo: twitterIconUrlsm
        }, {
            platform: 'LinkedIn',
            link: 'https://www.linkedin.com/in/yifanginhz/',
            content: 'Yifang Wang',
            platformLogo: linkedinIconUrlsm
        },
    ],
    contactPage: [
        {
            platform: 'Email',
            link: 'mailto:yifang.wang@fsu.edu',
            content: 'yifang.wang@fsu.edu',
            platformLogo: emailIconUrl
        },
        {
            platform: 'Google Scholar',
            link: 'https://scholar.google.com/citations?user=3qWVVUwAAAAJ&hl=en',
            content: 'Yifang Wang',
            platformLogo: scholarIconUrl
        },
        {
            platform: 'Github',
            link: 'https://github.com/WangYifang',
            content: '@WangYifang',
            platformLogo: githubIconUrl
        },
        {
            platform: 'Twitter',
            link: 'https://twitter.com/yifanginhz',
            content: '@yifanginhz',
            platformLogo: twitterIconUrl
        }, {
            platform: 'Bluesky',
            link: 'https://bsky.app/profile/yifangwang.bsky.social',
            content: '@yifangwang.bsky.social',
            platformLogo: blueskyIconUrl
        }, {
            platform: 'LinkedIn',
            link: 'https://www.linkedin.com/in/yifanginhz/',
            content: 'Yifang Wang',
            platformLogo: linkedinIconUrl
        }, {
            platform: '500px',
            link: 'https://500px.com.cn/yifangwang',
            content: 'https://500px.com.cn/yifangwang',
            platformLogo: photoIconUrl
        },
    ],
    lifePage: {
        hangzhou: 'Life at Hangzhou and Suzhou.', // 'I love Hangzhou, my hometown.',
        usa: 'Explore the world.',
        academicFamily: 'I\'m very lucky to have "grown up" in two incredible academic groups. We are more than collaborators, students, and supervisors--we are also friends and family.'
    }
}
